import { Component, OnInit, NgZone, ViewChild, AfterContentInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { DashboardComponent } from '../dashboard.component';
import { PartnersComponent } from '../partners/partners.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {PageEvent} from '@angular/material/paginator';
import { MatRadioChange } from '@angular/material/radio';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {MatSliderModule} from '@angular/material/slider';
import {take} from 'rxjs/operators';
import {FlatTreeControl} from '@angular/cdk/tree';

import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY / MM / DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-newinvoice',
  templateUrl: './newinvoice.component.html',
  styleUrls: ['./newinvoice.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class NewinvoiceComponent implements OnInit {

  constructor(private _ngZone: NgZone, public parent: DashboardComponent, private service:SharedService, private managementService:ManagementServiceService, private cookieService: CookieService, public translate: TranslateService, private route: ActivatedRoute, private router:Router) {

    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

     // Debounce search.
     this.searchPartnerUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        this.GetPartnersFiltered(value, this.countryID, true);
      });
      
      // Debounce search.
     this.productSearchTermUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        if(value != null && value.length > 2){
          this.SearchProductsInvoicingInformation(value, this.NewProduct?.ProductInvoiceInfo?.Administration?.ID, false);
        }
      });

        // Debounce search.
     this.hsSearchTermUpdate.pipe(
      debounceTime(300),
      distinctUntilChanged())
      .subscribe(value => {
        if(value != null && value.length > 2){
          this.GetHSCodesFiltered(value);
        }
      });
   }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  DocumentDate = new FormControl(moment());
  PaymentDueDate =  new FormControl(moment());
  
  loading:boolean;
  showSearch:boolean;
  showSearchCurrent:boolean;
  SubordonatesInfo:any;
  ShowSubordronateDocumentsWarning:boolean;
  ShowShippingDetailsContainer:boolean;

  // Shipping Details Container - Dropdown States
  showShippingServiceTypeDropdown: boolean = false;
  showShippingWayDropdown: boolean = false;
  showShippingResponsabilityDropdown: boolean = false;
  showShippingCompanyDropdown: boolean = false;
  showWeightTypeDropdown: boolean = false;

  // Shipping Details Container - Section Collapse States
  shippingGeneralInfoCollapsed: boolean = false;
  shippingBoxesCollapsed: boolean = false;

  receptionURLID:any;
  IsStorno:boolean;
  NewCopy:boolean;
  CurrentInvoice: {[k: string]: any} = {};
  searchTerm:string;
  countryID:number;
  IsValidNewProduct:boolean;
  DocumentBodyLoading:boolean;
  ExportAutoEvaluationLoading:boolean;
  showInvoiceVisualizer:boolean;

  resultsLength = 0;
  pageSize = 999999;
  Partners:any[];
  newPartner:any;

  partner:any;
  currentPartner:any;
  currency:any;

  newPartnerCountry:any;
  newPartnerBank:any;
  InvoicePrecision:any;
  SubordronateDocumentsMessage:string;

  showAddNewPartnerPopUp:boolean;
  showEditPartnerPopUp:boolean;

  Currencies:any[];
  DecimalPrecisions:any[];
  AccountingSeries:any[];
  Languages:any[];
  PaymentTerms:any[];
  Administrations:any[];
  MeasuringUnits:any[];
  VATRates:any[];
  ProductGeneralTypes:any[];
  DiscountTypes:any[];
  Agents:any[];
  DocTypes:any[];
  CashCollectTypes:any[];
  InvoiceDocType:any;
  masterData:any;
  showAccountingSeriesError:boolean;
  PurchaseInfos:any[];

  Products:any[];
  NewProduct: {[k: string]: any} = {
    ProductInvoiceInfo: {
      Administration: null,  // ✅ Changed from {} to null to prevent compareFn mismatch
      Code: '',
      Name: '',
      Price: {},
      Quantity: 0
    }
  };
  IsSignedByAgent:boolean;
  ShowDocumentError:boolean;

  ShippingWays:any[];
  ShippingServiceTypes:any[];
  ShippingResponsabilities:any[];
  ShippingCompanies:any[];
  WeightTypes:any[];
  ShippingMasterData:any;

  // Insurance Policy Master Data
  InsurancePolicyDictators:any[] = [
    { ID: 1, Name: 'INSURANCE_DICTATOR_PARTNER_POLICY' },
    { ID: 2, Name: 'INSURANCE_DICTATOR_SHIPPING_RESPONSIBILITY' }
  ];
  InsurancePolicyIllustrators:any[] = [
    { ID: 1, Name: 'INSURANCE_ILLUSTRATOR_SEPARATE_POSITION' },
    { ID: 2, Name: 'INSURANCE_ILLUSTRATOR_SUMMED_IN_SHIPPING' }
  ];

  searchPartnerUpdate = new Subject<string>();
  productSearchTermUpdate = new Subject<string>();
  hsSearchTermUpdate = new Subject<string>();

  triggerResize() {
    // Wait for changes to be applied, then trigger textarea resize.
    this._ngZone.onStable.pipe(take(1))
        .subscribe(() => this.autosize.resizeToFitContent(true));
  }

  ngOnInit(): void {
    this.loading = true;
    this.GetInvoiceMasterData();
    this.countryID = null;
    this.Products = new Array();
    this.initializeAddPartnerForm();
    this.showSearch = true;
    this.showSearchCurrent = true;
    
    this.GetShippingMasterData();
    this.parent.PreventBrowserClose(true);
    this.InitializeHSFilter();
  }

  showhideSearches(isFromPop:boolean){
    
    if(isFromPop){
      if(this.ProductsSearchResultsCOUNTPop > 0){
        this.showSearchCurrent = !this.showSearchCurrent;
      }
      else{
        this.showSearchCurrent = true;
      }
    }
    else{
      if(this.ProductsSearchResultsCOUNT > 0){
        this.showSearch = !this.showSearch;
      }
      else{
        this.showSearch = true;
      }
    }
  }

  GetInvoice(id:string, UseInvoiceLanguage:boolean, TransferAdvancedPaymentValues:boolean = false){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:id,
      WithInfo:true,
      IsNewStorno:this.IsStorno,
      NewCopy:this.NewCopy,
      UseInvoiceLanguage:UseInvoiceLanguage,
      TransferAdvancedPaymentValues:TransferAdvancedPaymentValues
    };

    this.service.GetInvoice(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar", 30000);
        this.ShowDocumentError = true;
      }
      else if(response["Status"] == 1){
        this.FillInvoiceInfo(response["Invoice"]);
        this.TestDocumentValidity();
      }

      if(this.CurrentInvoice?.ID?.length > 0 && this.CurrentInvoice?.DocType?.ID == 0 && this.CurrentInvoice.DocumentStatus.ID != -1){
        this.GetInvoicePurchasePrices();
      }
   
    });
  }

  GetInvoicePurchasePrices(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoiceID:this.CurrentInvoice.ID
    };
    
    this.parent.loading = true;
  
    this.service.GetInvoicePurchasePrices(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.PurchaseInfos = response["PurchaseInfos"];

       this.CurrentInvoice.Products.forEach(product => {
        this.PurchaseInfos.forEach(info => {
          
          if(product.ProductInvoiceInfo.ID == info.ParentID){
            product.ProductInvoiceInfo.PurchaseInfo = info;
          }

        });
       });

       this.CurrentInvoice.Total.TotalPurchaseCost = response["TotalPurchaseCost"];
       this.CurrentInvoice.Total.UITotalPurchaseCost = response["UITotalPurchaseCost"];
       this.CurrentInvoice.Total.TotalPurchaseCostVAT = response["TotalPurchaseCostVAT"];
       this.CurrentInvoice.Total.UITotalPurchaseCostVAT = response["UITotalPurchaseCostVAT"];

       var i = response["Invoice"];
       this.CurrentInvoice.Total.TotalPureProfit = i.Total.TotalPureProfit;
       this.CurrentInvoice.Total.TotalPurchaseInfoUIText = i.Total.TotalPurchaseInfoUIText;

       this.CurrentInvoice.PurchaseStatus = response["InvoicePurchaseStatus"];
      }
   
      this.parent.loading = false;
    });
  }

  FillInvoiceInfo(invoice:any){

    this.partner = {};
    this.CurrentInvoice = invoice;
    this.partner = this.CurrentInvoice.Client;

    this.DocumentDate = new FormControl(moment(this.CurrentInvoice.DocumentDate));
    this.PaymentDueDate =  new FormControl(moment(this.CurrentInvoice.PaymentDueDate));
    this.currency = invoice.Currency;

    if(invoice.Products.length > 0){
      this.InvoicePrecision = invoice.Products[0].ProductInvoiceInfo.DecimalPrecision;
    }

    this.Products = invoice.Products;
    this.IsStorno = invoice.IsStorno;

    if(this.NewCopy){
      this.CurrentInvoice.AccountingNumber.ID = null;
    }
  }

  getParamValues() {
    this.route.queryParams.subscribe(params => {   
      
      if(params['id']){
        this.receptionURLID = params['id'];
      }
        
      if(params['IsStorno']){
        this.IsStorno = JSON.parse(params['IsStorno']);
      }

      if(params['Type']){
        this.InvoiceDocType = JSON.parse(params['Type']);
        this.CurrentInvoice.DocType = this.DocTypes.find(x => x.ID == this.InvoiceDocType);
      }

      if(params['NewCopy']){
        this.NewCopy = JSON.parse(params['NewCopy']);
      }

        if(this.IsStorno == undefined){
          this.IsStorno = false;
        }
    });

    if(this.receptionURLID != undefined && this.receptionURLID != null){
      this.GetInvoice(this.receptionURLID, false);
    }
  }

  InitializeNewInvoice(){
    
    this.CurrentInvoice.PaymentTerm = null;
    this.CurrentInvoice.Language = this.parent.User.Settings.Language;
    this.CurrentInvoice.AccountingNumber = {};
    this.CurrentInvoice.AccountingNumber.ID = null;
    this.CurrentInvoice.AccountingNumber.AccountingSeries = {};
    this.CurrentInvoice.AccountingNumber.AccountingSeries = this.AccountingSeries[0];
    this.CurrentInvoice.Client = {};
    this.CurrentInvoice.Company = {};
    this.CurrentInvoice.Company = this.parent.Company;
    this.CurrentInvoice.DocType = {};
    this.CurrentInvoice.DocumentNumber = "";
    this.CurrentInvoice.DocumentDate = null;
    this.CurrentInvoice.PaymentDueDate = null;
    this.CurrentInvoice.StockEntryDate = null;
    this.CurrentInvoice.Currency = this.currency;
    this.CurrentInvoice.Currency.DecimalPrecision = this.InvoicePrecision;
    this.CurrentInvoice.Products = [];
    this.CurrentInvoice.Products = this.Products;
    this.CurrentInvoice.Details = {};

    this.CurrentInvoice.Details.Agent = {};
    this.CurrentInvoice.Details.Agent = this.Agents[0];
    this.CurrentInvoice.Details.WayBillID = "";
    this.CurrentInvoice.Details.Delegate = "";
    this.CurrentInvoice.Details.IDCard = "";
    this.CurrentInvoice.Details.Auto = "";
    this.CurrentInvoice.Details.InternalCommentary = "";
    this.CurrentInvoice.Details.Observations = "";
    this.CurrentInvoice.Details.CashCollections = [];
    this.CurrentInvoice.Details.StockDischarging = true;
    this.CurrentInvoice.Details.SignStampSubstitute = "";
    this.CurrentInvoice.Details.IsSignedByAgent = false;

    this.CurrentInvoice.ID = null;

    this.CurrentInvoice.DocumentStatus = {};
    this.CurrentInvoice.DocumentStatus.ID = 1;

    this.CurrentInvoice.IsStorno = this.IsStorno;

    this.CurrentInvoice.Total = {};
    this.CurrentInvoice.Total.Discount = {};
    this.IsSignedByAgent = false;
  }

  initializeAddPartnerForm(){
    this.newPartner = new FormGroup({

      VAT:new FormControl(''),
      UPN:new FormControl(''),
      Name:new FormControl('', [Validators.required]),
      COCRegNumber:new FormControl(''),
  
      TaxPayer:new FormControl(''),
  
      Country:new FormControl(''),
      StateProvince:new FormControl(''),
      City:new FormControl(''),
      AddressLine:new FormControl('', [Validators.required]),
      ZipCode:new FormControl(''),

      Bank:new FormControl(''),
      BankAccount:new FormControl(''),
  
      Email: new FormControl('', [Validators.email]),
      ContactName:new FormControl(''),
      Phone:new FormControl(''),
    });
  }

  GetInvoiceMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.service.GetInvoiceMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.masterData = response;
        this.Currencies = response["Currencies"];
        this.DecimalPrecisions = response["DecimalPrecisions"];
        this.AccountingSeries = response["AccountingSeries"];

        if(this.AccountingSeries == null || this.AccountingSeries.length == 0){
          if(this.receptionURLID == undefined || this.receptionURLID == null){
            this.OpenAccountingSeriesError();
          }
        }

        this.Languages = response["Languages"];
        this.PaymentTerms = response["PaymentTerms"];
        this.Administrations = response["Administrations"];
        this.MeasuringUnits = response["MeasuringUnits"];
        this.VATRates = response["VATRates"];
        this.ProductGeneralTypes = response["ProductGeneralTypes"];

        this.DiscountTypes = response["DiscountTypes"];
        this.Agents = response["Agents"];
        this.DocTypes = response["DocTypes"];
        this.CashCollectTypes = response["CashCollectTypes"];

        this.currency = this.Currencies[0];
        this.InvoicePrecision = this.DecimalPrecisions[0];
        this.InitializeNewProduct();
        this.InitializeNewInvoice();
        this.getParamValues();
      }
   
      this.NewProductPriceContainsVAT = false;
      this.parent.loading = false;
    });
  }

  GetShippingMasterData(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.service.GetShippingMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShippingWays = response["ShippingWays"];
        this.ShippingServiceTypes = response["ShippingServiceTypes"];
        this.ShippingResponsabilities = response["ShippingResponsabilities"];
        this.ShippingCompanies = response["ShippingCompanies"];
        this.WeightTypes = response["WeightTypes"];
        this.ShippingMasterData = response;
      }
    });
  }

  InitializePartnersOnClick(searchTerm:string, CountryID:number, resetPaging:boolean){
    var request = {
      SearchTerm:searchTerm,
      CountryID:CountryID,
      PageIndex:1,
      PageSize:10,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company,
      SearchEUVIES:true
    };

    if((this.searchTerm.length >= 3) && (this.Partners == null || this.Partners.length == 0)){
      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          if(response["NewPartnerDetected"] == true){
  
            var p = response["PendingPartner"];
            this.newPartner = new FormGroup({
  
              VAT:new FormControl(p.VAT),
              UPN:new FormControl(''),
              Name:new FormControl(p.Name, [Validators.required]),
              COCRegNumber:new FormControl(''),
          
              TaxPayer:new FormControl(p.EUVATVerified),
          
              Country:new FormControl(p.BillingAddress.Country),
              StateProvince:new FormControl(''),
              City:new FormControl(''),
              AddressLine:new FormControl(p.BillingAddress.AddressLine),
              ZipCode:new FormControl(''),
          
              Bank:new FormControl(''),
              BankAccount:new FormControl(''),
          
              Email: new FormControl('', [Validators.email]),
              ContactName:new FormControl(''),
              Phone:new FormControl(''),
            });
  
            this.showAddNewPartnerPopUp = true;
          }
          else{
            this.Partners = response["Partners"];
            this.resultsLength = response["Count"];
          }
        }
     
        this.parent.loading = false;
      });
    }
    else{
      this.Partners = [];
      this.resultsLength = 0;
    }
  }

  GetPartnersFiltered(searchTerm:string, CountryID:number, resetPaging:boolean){
    var request = {
      SearchTerm:searchTerm,
      CountryID:CountryID,
      PageIndex:1,
      PageSize:this.pageSize,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company,
      SearchEUVIES:true
    };

    if(this.searchTerm.length >= 3){
      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          if(response["NewPartnerDetected"] == true){
  
            var p = response["PendingPartner"];
            this.newPartner = new FormGroup({
  
              VAT:new FormControl(p.VAT),
              UPN:new FormControl(''),
              Name:new FormControl(p.Name, [Validators.required]),
              COCRegNumber:new FormControl(''),
          
              TaxPayer:new FormControl(p.EUVATVerified),
          
              Country:new FormControl(p.BillingAddress.Country),
              StateProvince:new FormControl(''),
              City:new FormControl(''),
              AddressLine:new FormControl(p.BillingAddress.AddressLine),
              ZipCode:new FormControl(''),
          
              Bank:new FormControl(''),
              BankAccount:new FormControl(''),
          
              Email: new FormControl('', [Validators.email]),
              ContactName:new FormControl(''),
              Phone:new FormControl(''),
            });
  
            this.showAddNewPartnerPopUp = true;
          }
          else{
            this.Partners = response["Partners"];
            this.resultsLength = response["Count"];
          }
        }
     
        this.parent.loading = false;
      });
    }
  }

  GetPartnerEUData(partner:any, addnew:boolean){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      VAT:partner.value.VAT,
      CountryCode:partner.value.Country.ShortName
    };

    this.parent.loading = true;

    this.service.GetPartnerEUData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1 && response["EUVATVerified"] == true){

        if(addnew){

          this.newPartner = new FormGroup({

            VAT:new FormControl(response["VAT"]),
            UPN:new FormControl(''),
            Name:new FormControl(response["Name"], [Validators.required]),
            COCRegNumber:new FormControl(''),
        
            TaxPayer:new FormControl(response["EUVATVerified"]),
        
            Country:new FormControl(response["Country"]),
            StateProvince:new FormControl(''),
            City:new FormControl(''),
            AddressLine:new FormControl(response["Address"], [Validators.required]),
            ZipCode:new FormControl(''),
        
            Bank:new FormControl(''),
            BankAccount:new FormControl(''),
        
            Email: new FormControl('', [Validators.email]),
            ContactName:new FormControl(''),
            Phone:new FormControl(''),
          });
        }
        else{

          this.currentPartner = new FormGroup({

            VAT:new FormControl(response["VAT"]),
            UPN:new FormControl(this.partner.UPN),
            Name:new FormControl(response["Name"], [Validators.required]),
            COCRegNumber:new FormControl(this.partner.COCRegNumber),
        
            TaxPayer:new FormControl(response["EUVATVerified"]),
        
            Country:new FormControl(response["Country"]),
            StateProvince:new FormControl(this.partner.BillingAddress.StateProvince, [Validators.required]),
            City:new FormControl(this.partner.BillingAddress.City, [Validators.required]),
            AddressLine:new FormControl(response["Address"], [Validators.required]),
            ZipCode:new FormControl(this.partner.BillingAddress.ZipCode),
        
            Bank:new FormControl(this.partner.Bank),
            BankAccount:new FormControl(this.partner.Bank.BankAccount),
        
            Email: new FormControl(this.partner.ContactInfo.Email, [Validators.email]),
            ContactName:new FormControl(this.partner.ContactInfo.Name),
            Phone:new FormControl(this.partner.ContactInfo.Phone),
          });

          this.partner.EUVATVerified = response["EUVATVerified"];
        }
      }
   
      this.parent.loading = false;
    });
  }

  OpenAccountingSeriesError(){
    this.showAccountingSeriesError = true;
  }

  AddNewPartner(){

    var request = {
      Partner:{
        VAT:this.newPartner.controls['VAT'].value,
        UPN:this.newPartner.controls['UPN'].value,
        Name:this.newPartner.controls['Name'].value,
        COCRegNumber:this.newPartner.controls['COCRegNumber'].value,

        TaxPayer:false,

        BillingAddress:{
          Country:this.newPartner.controls['Country'].value,
          StateProvince:this.newPartner.controls['StateProvince'].value,
          City:this.newPartner.controls['City'].value,
          AddressLine:this.newPartner.controls['AddressLine'].value,
          ZipCode:this.newPartner.controls['ZipCode'].value,
        },
        Bank:this.newPartnerBank,
        ContactInfo:{
          Email:this.newPartner.controls['Email'].value,
          Name:this.newPartner.controls['ContactName'].value,
          Phone:this.newPartner.controls['Phone'].value,
        },
        Company:this.parent.Company
      },
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    if(request.Partner.Bank != null){
      request.Partner.Bank.BankAccount = this.newPartner.controls['BankAccount'].value;
    }

    if(this.newPartner.controls['TaxPayer'].touched != false && this.newPartner.controls['TaxPayer'].value != ''){
      request.Partner.TaxPayer = this.newPartner.controls['TaxPayer'].value;
    }
    else{
      request.Partner.TaxPayer = false;
    }
    
    if(this.newPartner.valid){

      this.parent.loading = true;

      this.service.AddNewPartner(request).subscribe(response => {

        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          if(response["DuplicateDetected"]){
            this.parent.openSnackBar(this.parent.translate.instant("Management.DuplicatePartnerDetected") + ": " + (response["Partner"]?.Name || response["Message"]), "OK", "alert-danger-snackbar");
          } else {
            this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
          }
          this.initializeAddPartnerForm();
          this.showAddNewPartnerPopUp = false;
          this.GetPartnerOnAdd(response["ID"]);
        }

        this.parent.loading = false;
      });
       };

     if(!this.newPartner.valid){
      this.newPartner.controls['Name'].touched = true;
      this.newPartner.controls['Country'].touched = true;
      this.newPartner.controls['StateProvince'].touched = true;
      this.newPartner.controls['City'].touched = true;
      this.newPartner.controls['AddressLine'].touched = true;
      this.newPartner.controls['ZipCode'].touched = true;
      }

    }

  GetPartnerOnAdd(id:string){

      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        PartnerID:id
      };
  
      this.parent.loading = true;
  
      this.service.GetPartner(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.partner = response["Partner"];
          this.resultsLength = 0;
          this.searchTerm='';
          this.AdjustCurrencyOnPartnerSeleciton();
          this.TestDocumentValidity();
        }
     
        this.parent.loading = false;
      });
  }

    InsertPartnerFromCloud(partner:any){

      var request = {
        Partner:partner,
        User:this.parent.User,
        Language:this.parent.getLanguage(),
      };
  
      this.parent.loading = true;
  
      this.service.AddNewPartner(request).subscribe(response => {

        if(response["Status"] != 1){

        }
        else if(response["Status"] == 1){
          this.partner.ID = response["ID"];
          this.partner.EUVATVerified = response["EUVATVerified"];
          if(response["DuplicateDetected"]){
            this.parent.openSnackBar(this.parent.translate.instant("Management.DuplicatePartnerDetected") + ": " + (response["Partner"]?.Name || ""), "OK", "alert-danger-snackbar");
          } else {
            this.parent.openSnackBar(this.parent.translate.instant("Management.AddNewPartner"), "OK", "light-info-snackbar");
          }
        }

        this.parent.loading = false;
      });
    }

    initializePartnerFormFromObject(partner:any){

      this.currentPartner = new FormGroup({
  
        VAT:new FormControl(partner.VAT),
        UPN:new FormControl(partner.UPN),
        Name:new FormControl(partner.Name, [Validators.required]),
        COCRegNumber:new FormControl(partner.COCRegNumber),
    
        TaxPayer:new FormControl(partner.TaxPayer),
    
        Country:new FormControl(partner.BillingAddress.Country),
        StateProvince:new FormControl(partner.BillingAddress.StateProvince, [Validators.required]),
        City:new FormControl(partner.BillingAddress.City, [Validators.required]),
        AddressLine:new FormControl(partner.BillingAddress.AddressLine, [Validators.required]),
        ZipCode:new FormControl(partner.BillingAddress.ZipCode),
    
        Bank:new FormControl(partner.Bank),
        BankAccount:new FormControl(partner.Bank.BankAccount),
    
        Email: new FormControl(partner.ContactInfo.Email, [Validators.email]),
        ContactName:new FormControl(partner.ContactInfo.Name),
        Phone:new FormControl(partner.ContactInfo.Phone),
      });
     
      this.showEditPartnerPopUp = true;
      this.partner = partner;
    }

    UpdatePartner(){
      var request = {
        Partner:{
          ID:String,
          VAT:this.currentPartner.controls['VAT'].value,
          UPN:this.currentPartner.controls['UPN'].value,
          Name:this.currentPartner.controls['Name'].value,
          COCRegNumber:this.currentPartner.controls['COCRegNumber'].value,
  
          TaxPayer:this.currentPartner.controls['TaxPayer'].value,
  
          BillingAddress:{
            ID:Number,
            Country:this.currentPartner.controls['Country'].value,
            StateProvince:this.currentPartner.controls['StateProvince'].value,
            City:this.currentPartner.controls['City'].value,
            AddressLine:this.currentPartner.controls['AddressLine'].value,
            ZipCode:this.currentPartner.controls['ZipCode'].value,
          },
          Bank:this.currentPartner.controls['Bank'].value,
          ContactInfo:{
            ID:Number,
            Email:this.currentPartner.controls['Email'].value,
            Name:this.currentPartner.controls['ContactName'].value,
            Phone:this.currentPartner.controls['Phone'].value,
          },
          Company:this.parent.Company,
          EUVATVerified:this.partner.EUVATVerified,
        },
        User:this.parent.User,
        Language:this.parent.getLanguage()
      };
  
      request.Partner.Bank.BankAccount = this.currentPartner.controls['BankAccount'].value;
      request.Partner.ID = this.partner.ID;
      request.Partner.BillingAddress.ID = this.partner.BillingAddress.ID;
      request.Partner.ContactInfo.ID = this.partner.ContactInfo.ID;
  
      this.parent.loading = true;
  
      this.service.UpdatePartner(request).subscribe(response => {
     
        if(response["Status"] != 1){
        
        }
        else if(response["Status"] == 1){
         this.showEditPartnerPopUp = false;
         this.parent.openSnackBar("Partner Updated", "OK", "light-info-snackbar");
         this.partner = response["Partner"];
        }
     
        this.parent.loading = false;
      });
    }

    compareFn(c1: any, c2: any): boolean {
      return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
  }
  
    compareFirst(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
  }

  GetCurrencyLiveExchange(currency:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Currency:currency
    };

    this.parent.loading = true;

    this.service.GetCurrencyLiveExchange(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.currency = response["Currency"];
      }
   
      this.parent.loading = false;
    });
  }

  AdjustLanguageOnPartnerSeleciton(){
    this.CurrentInvoice.Language = this.partner.BillingAddress.Country.Language;
  }

  AdjustCurrencyOnPartnerSeleciton(){
    this.GetCurrencyLiveExchange(this.partner.BillingAddress.Country.Currency);
  }

  AdjustPaymentTermOnPartnerSelect(id){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:id,
      DocType:this.CurrentInvoice.DocType
    };

    this.parent.loading = true;

    this.service.AdjustPaymentTermOnPartnerSelect(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentInvoice.PaymentTerm = response["Term"];

        if(this.CurrentInvoice.PaymentTerm){
          this.GetDateByPaymentTerm(this.CurrentInvoice.PaymentTerm);
        }
      }
   
      this.parent.loading = false;
    });
  }

  GetDateByPaymentTerm(term:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Term:term,
      DocumentDate:null
    };

    if(this.DocumentDate.value != undefined && this.DocumentDate.value != null){

      if(this.DocumentDate.value._d == null || this.DocumentDate.value._d == undefined){
        this.DocumentDate = new FormControl(moment(this.CurrentInvoice.DocumentDate));
      }

      if(this.DocumentDate.value._d != undefined){
        request.DocumentDate = moment(this.DocumentDate.value._d).format('YYYY-MM-DD');
      }
    }

    this.parent.loading = true;

    this.service.GetDateByPaymentTerm(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.DocumentDate = new FormControl(moment(response["DocumentDate"]));
        this.PaymentDueDate =  new FormControl(moment(response["DueDate"]));
      }
   
      this.parent.loading = false;
    });
  }

  InitializeNewProduct(){

    var Administration = null;

    if(this.NewProduct?.ProductInvoiceInfo?.Administration != null){
      Administration = JSON.parse(JSON.stringify(this.NewProduct?.ProductInvoiceInfo?.Administration));
    }
    else if(this.Administrations && this.Administrations.length > 0){
      // ✅ Only set default Administration if array exists and has items
      Administration = JSON.parse(JSON.stringify(this.Administrations[0]));
    }

    this.NewProduct = {
      ID:null,
      GeneralType:this.ProductGeneralTypes[0],
      ProductInvoiceInfo:{
        Administration:Administration,
        Name:"",
        Code:"",
        Description:"",
        MeasuringUnit:this.MeasuringUnits[0],
        Quantity:1,
        Price:{
          VAT:this.VATRates[0]
        },
        Total:null,
        TotalVATValue:null,
      },
    };

    this.IsValidNewProduct = false;
  }

  chanveNewProductVALUE(event){
    
    this.IsValidNewProduct = false;

    if(this.NewProduct.ProductInvoiceInfo.Administration != null){
      if(this.NewProduct.ProductInvoiceInfo.MeasuringUnit != null){
        if(this.NewProduct.ProductInvoiceInfo.Price.VAT != null){
          if(this.InvoicePrecision != null){
            if(this.NewProduct.ProductInvoiceInfo.Name != null && this.NewProduct.ProductInvoiceInfo.Name.length > 0){
              if(this.NewProduct.ProductInvoiceInfo.Code != null && this.NewProduct.ProductInvoiceInfo.Code.length > 0){
                if(this.NewProduct.ProductInvoiceInfo.Price != null){
                  if((this.NewProduct.ProductInvoiceInfo.Price.UIVATUnitPrice != null && this.NewProduct.ProductInvoiceInfo.Price.UIVATUnitPrice.toString().length > 0 && this.NewProductPriceContainsVAT) || (this.NewProduct.ProductInvoiceInfo.Price.UIUnitPrice != null && this.NewProduct.ProductInvoiceInfo.Price.UIUnitPrice.toString().length > 0 && !this.NewProductPriceContainsVAT)){
                    if(this.NewProduct.ProductInvoiceInfo.Quantity > 0 && this.NewProduct.ProductInvoiceInfo.Code.length > 0 && this.NewProduct.ProductInvoiceInfo.Name.length > 0){
                      this.IsValidNewProduct = true;
                    }
                  }
                }
              }
           }
          }
        }
      }
    }
  }

  loadingSearchProducts:boolean;
  ProductsSearchResults:any[];
  ProductsSearchResultsCOUNT:number;
  ProductsSearchResultsPop:any;
  ProductsSearchResultsCOUNTPop:any;
  NewProductPriceContainsVAT:boolean;

  GetProductsFiltered(searchTermProducts:string, administrationID:number, isFromPopUp:boolean){

    var request = {
      SearchTerm:searchTermProducts,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      AdministrationID:administrationID,
      PageIndex:1,
      PageSize:this.pageSize,
      IncludeStock:false
    };

    if(searchTermProducts.length >= 3){
      this.loadingSearchProducts = true;

      this.service.GetProductsFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){

          if(!isFromPopUp){
            this.ProductsSearchResults = response["Products"];
            this.ProductsSearchResultsCOUNT = response["Count"];
          }
        else{
          this.ProductsSearchResultsPop = response["Products"];
          this.ProductsSearchResultsCOUNTPop = response["Count"];
        }
        }
     
        this.loadingSearchProducts = false;
      });
    }
  }

  SearchProductsInvoicingInformation(searchTermProducts:string, administrationID:number, isFromPopUp:boolean){

    var request = {
      SearchTerm:searchTermProducts,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      AdministrationID:administrationID,
      PageIndex:1,
      PageSize:10,
      IncludeStock:false,
      Partner:this.partner,
      GeneralDocType:this.parent.masterData.GeneralDocTypes[1].ID,
      InvoiceMasterData:this.masterData,
      NewProductPriceContainsVAT:this.NewProductPriceContainsVAT,
      DecimalPrecision:this.InvoicePrecision,
      SuggestFromPool:true,
    };

    if(searchTermProducts != null && searchTermProducts.length >= 3){
      this.loadingSearchProducts = true;

      this.service.SuggestProducts(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){

          if(!isFromPopUp){
            this.ProductsSearchResults = response["Products"];
            this.ProductsSearchResultsCOUNT = response["Count"];
          }
        else{
          this.ProductsSearchResultsPop = response["Products"];
          this.ProductsSearchResultsCOUNTPop = response["Count"];
        }
        }
     
        this.loadingSearchProducts = false;
      });
    }
  }

  GetMostRecentProductInformation(p:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      GeneralDocType:this.parent.masterData.GeneralDocTypes[1].ID,
      DecimalPrecision:this.InvoicePrecision,
      Product:p,
      Partner:this.partner,
      PartnerIsClient:true,
    };
   
      this.loadingSearchProducts = true;

      this.service.GetMostRecentProductInformation(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.NewProduct = response["Product"];
          this.IsValidNewProduct = false;
          this.chanveNewProductVALUE(null);
        }
     
        this.CheckAndGetProductSubordonates(this.NewProduct);
        this.loadingSearchProducts = false;
      });
  }

  AddProductToInvoice(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Price:this.NewProduct.ProductInvoiceInfo.Price,
      Precision:this.InvoicePrecision.ID,
      HasVAT:this.NewProductPriceContainsVAT,
      Quantity:this.NewProduct.ProductInvoiceInfo.Quantity,
      DocQuantity:this.NewProduct.ProductInvoiceInfo.DocQuantity,
      IsStorno:this.IsStorno,
      AdvancePaymentPercentage:this.CurrentInvoice.AdvancePaymentPercentage
    };
  
    this.parent.loading = true;

    this.service.GetPriceInformation(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){

          var aux = JSON.parse(JSON.stringify(this.NewProduct));

          aux.ProductInvoiceInfo.Price = response["Price"];

          aux.ProductInvoiceInfo.Price.Currency = this.currency;
          aux.ProductInvoiceInfo.DecimalPrecision = this.InvoicePrecision;
          aux.ProductInvoiceInfo.PriceContainsVAT = this.NewProductPriceContainsVAT;
          aux.ProductInvoiceInfo.GeneralType = this.NewProduct.GeneralType;
          aux.ProductInvoiceInfo.Quantity = response["Quantity"];
         
          aux.ProductInvoiceInfo.UIID = this.parent.newGuid();
          this.Products.push(aux);
          this.ProofAllocatesSubordonatesQuantites();
          this.TestDocumentValidity();
      }
   
      this.GetInvoiceTotalValues();
      this.InitializeNewProduct();
      this.parent.loading = false;
    });

  }

  GetInvoiceTotalValues(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Products:JSON.parse(JSON.stringify(this.Products)),
      Precision:this.InvoicePrecision.ID,
      IsStorno:this.IsStorno
    };

    this.parent.loading = true;

    this.service.GetInvoiceTotalValues(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){

        this.CurrentInvoice.Total.TotalQtyPriceNOVAT = response["Total"].TotalQtyPriceNOVAT;
        this.CurrentInvoice.Total.TotalVAT = response["Total"].TotalVAT;
        this.CurrentInvoice.Total.TotalQtyPriceVAT = response["Total"].TotalQtyPriceVAT;
      }
   
      this.parent.loading = false;
    });

  }

  loadingEditProduct:boolean;

  GetSingleExchange(price:any, exchangeRate:any, targetMainCurrency:boolean, precision:any): any{

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Price:price,
      ExchangeRate:exchangeRate,
      IsTargetMainCurrency:targetMainCurrency,
      Precision:precision
    };

    this.loadingEditProduct = true;

    this.service.GetSingleExchange(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        return response["Price"];
      }
   
      this.loadingEditProduct = false;
    });

    return null;
  }

  DeleteAuxProduct(id:string){
    this.Products = this.Products.filter(item => item.ProductInvoiceInfo.UIID != id);
    this.ProofAllocatesSubordonatesQuantites();
    this.GetInvoiceTotalValues();
  }

  CurrentProduct:any;
  CurrentIndexProduct:number;

  SelectReceptionProductFromSearch(product:any){

    if(product.ProductInvoiceInfo != null){
      this.NewProduct = product;
      this.NewProductPriceContainsVAT = this.NewProduct.ProductInvoiceInfo.PriceContainsVAT;
    }
    else{
      this.NewProduct = {
        ID:null,
        GeneralType:product.GeneralType,
        ProductInvoiceInfo:{
          Administration:product.Administration,
          Name:product.Name,
          Code:product.Code,
          Description:product.Description,
          MeasuringUnit:this.MeasuringUnits[0],
          Quantity:1,
          Price:{
            VAT:this.VATRates[0]
          },
          Total:null,
          TotalVATValue:null,
        },
      };
    }

    this.GetMostRecentProductInformation(this.NewProduct);
    this.ProductsSearchResultsCOUNT = 0;
    this.ProductsSearchResults = [];
  }

  SelectReceptionProductFromSearchCurrent(product:any){
    
    if(product.ProductInvoiceInfo != null){
      product.ProductInvoiceInfo.ProductID = product.ID;
      product.ProductInvoiceInfo.DecimalPrecision = this.CurrentProduct.ProductInvoiceInfo.DecimalPrecision;
      product.ProductInvoiceInfo.Description = this.CurrentProduct.ProductInvoiceInfo.Description;
      product.ProductInvoiceInfo.DescriptionRows = this.CurrentProduct.ProductInvoiceInfo.DescriptionRows;
      product.ProductInvoiceInfo.Quantity = this.CurrentProduct.ProductInvoiceInfo.Quantity;
      product.ProductInvoiceInfo.Price = this.CurrentProduct.ProductInvoiceInfo.Price;
      product.ProductInvoiceInfo.PriceContainsVAT = this.CurrentProduct.ProductInvoiceInfo.PriceContainsVAT;
      product.ProductInvoiceInfo.Total = this.CurrentProduct.ProductInvoiceInfo.Total;
      product.ProductInvoiceInfo.TotalVATValue = this.CurrentProduct.ProductInvoiceInfo.TotalVATValue;
      product.ProductInvoiceInfo.VAT = this.CurrentProduct.ProductInvoiceInfo.VAT;

      this.CurrentProduct = product;
      this.NewProductPriceContainsVAT = this.CurrentProduct.ProductInvoiceInfo.PriceContainsVAT;
    }
    else{
      this.NewProduct = {
        ID:null,
        GeneralType:product.GeneralType,
        ProductInvoiceInfo:{
          Administration:product.Administration,
          Name:product.Name,
          Code:product.Code,
          Description:product.Description,
          MeasuringUnit:this.MeasuringUnits[0],
          Quantity:1,
          Price:{
            VAT:this.VATRates[0]
          },
          Total:null,
          TotalVATValue:null,
        },
      };
    }
    
    this.GetMostRecentProductInformation(this.NewProduct);
    this.ProductsSearchResultsCOUNTPop = 0;
    this.ProductsSearchResultsPop = [];
  }

  CheckAndGetProductSubordonates(p:any){
    if(p.ProductInvoiceInfo.Quantity > 0 && p.ProductInvoiceInfo.Quantity > p.DiscrepancyAmmount){
      this.GetSubordonateProducts(p);
    }
  }

  GetSubordonateProducts(p:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PageIndex:1,
      PageSize:10,
      Product:p
    };

    if(this.CurrentInvoice.DocType.ID == 0 && this.CurrentInvoice.ID == null){
      this.loadingSearchProducts = true;

      this.service.GetSubordonateProducts(request).subscribe(response => {
     
        if(response["Status"] != 1){
          
        }
        else if(response["Status"] == 1){
          this.NewProduct.SubordonatesInfo = response["SubordonatesInfo"];
        }
     
        this.loadingSearchProducts = false;
      });
    }
  }

  ShowReceptionEditProductContainer:boolean;
  ReserveProduct:any;

  OpenReceptionEditProduct(id:string){

    this.Products.forEach(p => {
      if(p.ProductInvoiceInfo.UIID == id){
        this.CurrentProduct = JSON.parse(JSON.stringify(p));
        this.ReserveProduct = JSON.parse(JSON.stringify(this.CurrentProduct));
        this.ShowReceptionEditProductContainer = true;
      }
    });
  }

  RevertProduct(){
    this.CurrentProduct = this.ReserveProduct;

    for (let i = 0; i < this.Products.length ; i++) {
      if(this.Products[i].ProductInvoiceInfo.UIID == this.CurrentProduct.ProductInvoiceInfo.UIID){
        this.Products[i] = JSON.parse(JSON.stringify(this.CurrentProduct));
      }
    }
    
  }

  showProductDiscountContainer:boolean;

  ModifyReceptionProduct(maintainOpenPopUp:boolean = false){

    var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Price:this.CurrentProduct.ProductInvoiceInfo.Price,
        Precision:this.InvoicePrecision.ID,
        HasVAT:this.CurrentProduct.ProductInvoiceInfo.PriceContainsVAT,
        Quantity:this.CurrentProduct.ProductInvoiceInfo.Quantity,
        DocQuantity:this.CurrentProduct.ProductInvoiceInfo.DocQuantity,
        IsStorno:this.IsStorno,
        Discount:null,
        AdvancePaymentPercentage:this.CurrentInvoice.AdvancePaymentPercentage
      };
  
      if(this.CurrentProduct.ProductInvoiceInfo.Price.Discount != undefined){
        request.Discount = this.CurrentProduct.ProductInvoiceInfo.Price.Discount;
      }
  
      if(maintainOpenPopUp == false){
        this.loadingEditProduct = true;
      }
  
      this.service.GetPriceInformation(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
           
            this.CurrentProduct.ProductInvoiceInfo.Quantity = response["Quantity"];
            this.CurrentProduct.ProductInvoiceInfo.DocQuantity = response["DocQuantity"];
  
            this.CurrentProduct.ProductInvoiceInfo.Price = response["Price"];
            
            if(maintainOpenPopUp == false){
              this.ShowReceptionEditProductContainer = false;
            }

            this.showProductDiscountContainer = false;

            if(this.CurrentProduct.ProductInvoiceInfo.ProductID != this.Products[this.CurrentIndexProduct]?.ProductInvoiceInfo?.ProductID){
              this.CurrentProduct.ProductInvoiceInfo.ID = null;
            }

            this.GenerateDescriptionRows();
            this.Products[this.CurrentIndexProduct] = JSON.parse(JSON.stringify(this.CurrentProduct));
        }
        
        this.ProofAllocatesSubordonatesQuantites();
        this.GetInvoiceTotalValues();
        this.loadingEditProduct = false;
      });
    }

    priceContainsVATchanged($event){

      if($event.checked == true){
  
        if(this.CurrentProduct != null){
          this.CurrentProduct.ProductInvoiceInfo.Price.UIVATUnitPrice = JSON.parse(JSON.stringify(this.CurrentProduct.ProductInvoiceInfo.Price.UIUnitPrice));
        }
  
        if(this.NewProduct != null){
          this.NewProduct.ProductInvoiceInfo.Price.UIVATUnitPrice = JSON.parse(JSON.stringify(this.NewProduct.ProductInvoiceInfo.Price.UIUnitPrice));
        }
      }
      else{
        if(this.CurrentProduct != null){
          this.CurrentProduct.ProductInvoiceInfo.Price.UIUnitPrice = JSON.parse(JSON.stringify(this.CurrentProduct.ProductInvoiceInfo.Price.UIVATUnitPrice));
        }
  
        if(this.NewProduct != null){
          this.NewProduct.ProductInvoiceInfo.Price.UIUnitPrice = JSON.parse(JSON.stringify(this.NewProduct.ProductInvoiceInfo.Price.UIUnitPrice));
        }
      }
  
      if(this.CurrentProduct != null){
        this.ModifyReceptionProduct(true);
      }
    }

    GenerateDescriptionRows(){
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Description:this.CurrentProduct.ProductInvoiceInfo.Description
      };

      this.loadingEditProduct = true;
  
      this.service.GenerateDescriptionRows(request).subscribe(response => {
        if(response["Status"] == 1){
          this.CurrentProduct.ProductInvoiceInfo.DescriptionRows = response["DescriptionRows"];
          this.Products[this.CurrentIndexProduct] = JSON.parse(JSON.stringify(this.CurrentProduct));
        }
      });
    }

    OpenProductDiscountContainer(p:any){

      if(p != null){
        this.CurrentProduct = JSON.parse(JSON.stringify(p));
        this.showProductDiscountContainer = true;
      }
    }

    showDocumentDiscountContainer:boolean;
  
    OpenDocumentDiscountContainer(){
      this.showDocumentDiscountContainer = true;
    }

    ApplyDiscount(){

      this.Products.forEach(p => {
        if(p.ProductInvoiceInfo.UIID == this.CurrentProduct.ProductInvoiceInfo.UIID){
          p.ProductInvoiceInfo = this.CurrentProduct.ProductInvoiceInfo;
          this.ModifyReceptionProduct();
        }
      });
      
    }

    DestroySearchedProducts(){
      this.ProductsSearchResultsCOUNT = 0;
      this.ProductsSearchResults = [];

      if(this.NewProduct != undefined){
        if(this.NewProduct.ProductInvoiceInfo != null){
          this.NewProduct.ProductInvoiceInfo.Name = "";
          this.NewProduct.ProductInvoiceInfo.Code = "";
          this.NewProduct.ProductInvoiceInfo.ProductID = null;
        }

        this.NewProduct.ID = null;
        this.NewProduct.SubordonatesInfo = null;
      }
      
      if(this.CurrentProduct != undefined){
        if(this.CurrentProduct.ProductInvoiceInfo != null){
          this.CurrentProduct.ProductInvoiceInfo.Name = "";
          this.CurrentProduct.ProductInvoiceInfo.Code = "";
          this.CurrentProduct.ProductInvoiceInfo.ProductID = null;
        }

          this.CurrentProduct.ID = null;
          this.CurrentProduct.SubordonatesInfo = null;
      }
      
      this.IsValidNewProduct = false;
      this.ProductsSearchResultsCOUNTPop = 0;
      this.ProductsSearchResultsPop = [];
    }

    ApplyInvoiceDiscount(){

      this.CurrentInvoice.Currency.DecimalPrecision = this.InvoicePrecision;

      if (this.DocumentDate.value._d != undefined) {
        this.CurrentInvoice.DocumentDate = moment(this.DocumentDate.value._d).format('YYYY-MM-DD');
      }
    
      if (this.PaymentDueDate.value._d != undefined) {
        this.CurrentInvoice.PaymentDueDate = moment(this.PaymentDueDate.value._d).format('YYYY-MM-DD');
      }

      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Invoice:JSON.parse(JSON.stringify(this.CurrentInvoice))
      };
  
      request.Invoice.Products = JSON.parse(JSON.stringify(this.Products));
  
      this.parent.loading = true;
  
      this.service.ApplyInvoiceDiscount(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.CurrentInvoice = response["Invoice"];
          this.Products = response["Invoice"].Products;

          this.DocumentDate = new FormControl(moment(this.CurrentInvoice.DocumentDate));
          this.PaymentDueDate =  new FormControl(moment(this.CurrentInvoice.PaymentDueDate));
        }
     
        this.showDocumentDiscountContainer = false;
        this.parent.loading = false;
      });
    }

    EliminateDocumentDiscount(){
      this.CurrentInvoice.Total.Discount = {
        Type:null,
        Value:null
      };
  
      this.ApplyInvoiceDiscount();
    }

    EliminateProductDiscount(){
      this.CurrentProduct.ProductInvoiceInfo.Price.Discount = {
        Type:null,
        Value:null
      };
  
      this.ModifyReceptionProduct();
    }

    AdjustProductsDecimalPrecisionPrice(){

      setTimeout(()=>{                         
        if(this.Products != undefined && this.Products != null && this.Products.length > 0){
          this.Products.forEach(p => {
            this.CurrentProduct = JSON.parse(JSON.stringify(p));
            this.CurrentProduct.ProductInvoiceInfo.DecimalPrecision = this.InvoicePrecision;

            var request = {
              User:this.parent.User,
              Language:this.parent.getLanguage(),
              Price:this.CurrentProduct.ProductInvoiceInfo.Price,
              Precision:this.InvoicePrecision.ID,
              HasVAT:this.CurrentProduct.ProductInvoiceInfo.PriceContainsVAT,
              Quantity:this.CurrentProduct.ProductInvoiceInfo.Quantity,
              DocQuantity:this.CurrentProduct.ProductInvoiceInfo.DocQuantity,
              IsStorno:this.IsStorno,
              Discount:null
            };
        
            if(this.CurrentProduct.ProductInvoiceInfo.Price.Discount != undefined){
              request.Discount = this.CurrentProduct.ProductInvoiceInfo.Price.Discount;
            }
        
            this.service.GetPriceInformation(request).subscribe(response => {
           
              if(response["Status"] != 1){
                this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
              }
              else if(response["Status"] == 1){
                 
                  this.CurrentProduct.ProductInvoiceInfo.Quantity = response["Quantity"];
                  this.CurrentProduct.ProductInvoiceInfo.DocQuantity = response["DocQuantity"];
                  this.CurrentProduct.ProductInvoiceInfo.Price = response["Price"];
                  p.ProductInvoiceInfo.Price = this.CurrentProduct.ProductInvoiceInfo.Price;
                  p.ProductInvoiceInfo.DecimalPrecision = this.InvoicePrecision;
                  this.GetInvoiceTotalValues();
              }
            });
          });
        }
      }, 0);
  }

  SalesDocumentsPairsCOUNT:number;

  AddInvoice(IgnoreSubordonates = false, DirectSubordonateDocumentsInjection = false){

    this.CurrentInvoice.Client = this.partner;
    this.CurrentInvoice.Currency = this.currency;
    
    if (this.DocumentDate.value._d != undefined) {
      this.CurrentInvoice.DocumentDate = moment(this.DocumentDate.value._d).format('YYYY-MM-DD');
    }
  
    if (this.PaymentDueDate.value._d != undefined) {
      this.CurrentInvoice.PaymentDueDate = moment(this.PaymentDueDate.value._d).format('YYYY-MM-DD');
    }

    this.CurrentInvoice.Currency.DecimalPrecision = this.InvoicePrecision;
    this.CurrentInvoice.Products = this.Products;
    this.CurrentInvoice.IsStorno = this.IsStorno;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Invoice:this.CurrentInvoice,
      IgnoreSubordonates:IgnoreSubordonates,
      DirectSubordonateDocumentsInjection:DirectSubordonateDocumentsInjection
    };

    this.ShowSubordronateDocumentsWarning = false;
    this.parent.loading = true;

    this.service.AddInvoiceFromAccountingAPI(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){

        if(response["ID"] != null){
          this.CurrentInvoice.ID = response["ID"];
          this.NewCopy = false;
          this.IsStorno = false;
          this.GetInvoice(this.CurrentInvoice.ID, true, true);
          this.showInvoiceVisualizer = true;
        }
        else if(response["ShowSubordronateDocumentsWarning"] == true){
          this.ShowSubordronateDocumentsWarning = true;
          this.SubordronateDocumentsMessage = response["SubordronateDocumentsMessage"];
          this.SalesDocumentsPairsCOUNT = response["SalesDocumentsPairs"].length;
        }
      }

      this.DocumentDate = new FormControl(moment(this.CurrentInvoice.DocumentDate));
      this.PaymentDueDate =  new FormControl(moment(this.CurrentInvoice.PaymentDueDate));
      this.parent.loading = false;
    });
  }

  ExtractTranzactionsFromSubordonateInfo(){

    this.CurrentInvoice.Client = this.partner;
    this.CurrentInvoice.Currency = this.currency;
    
    if (this.DocumentDate.value._d != undefined) {
      this.CurrentInvoice.DocumentDate = moment(this.DocumentDate.value._d).format('YYYY-MM-DD');
    }
  
    if (this.PaymentDueDate.value._d != undefined) {
      this.CurrentInvoice.PaymentDueDate = moment(this.PaymentDueDate.value._d).format('YYYY-MM-DD');
    }

    this.CurrentInvoice.Currency.DecimalPrecision = this.InvoicePrecision;
    this.CurrentInvoice.Products = this.Products;
    this.CurrentInvoice.IsStorno = this.IsStorno;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Invoice:this.CurrentInvoice
    };

    this.parent.loading = true;

    this.service.ExtractTranzactionsFromSubordonateInfo(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
      
      }

      this.DocumentDate = new FormControl(moment(this.CurrentInvoice.DocumentDate));
      this.PaymentDueDate =  new FormControl(moment(this.CurrentInvoice.PaymentDueDate));
      this.parent.loading = false;
    });
  }

  GetEFacturaXML(i:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoiceID:i.ID,
      UseInvoiceLanguage:false,
    };
  
    this.DocumentBodyLoading = true;
  
    this.service.GetEFacturaXML(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.download(Document.Name, Document.PDFStream);
      }
  
      this.DocumentBodyLoading = false;
    });
  }

  GetEFacturaState(i:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoiceID:this.CurrentInvoice.ID,
    };
  
    this.DocumentBodyLoading = true;
  
    this.service.GetEFacturaState(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentInvoice.Details.EFacturaDetails = response["EFacturaDetails"];
      }
  
      this.DocumentBodyLoading = false;
    });
  }

  GetEFacturaFiles(i:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoiceID:this.CurrentInvoice.ID,
      InvoiceDetailsID:this.CurrentInvoice.Details.ID,
      FileType:1,
    };
  
    this.DocumentBodyLoading = true;
  
    this.service.GetEFacturaFiles(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        this.GetEFacturaState(i); 
      }
      else if(response["Status"] == 1){
        if(request.FileType == 1){
          var PDF = response["PDF"];
          this.download(PDF.Name, PDF.PDFStream);
        }
        else if(request.FileType == 2){
          var XML = response["XML"];
          this.download(XML.Name, XML.PDFStream);
        }
        else if(request.FileType == 0){

          var PDF = response["PDF"];
          this.download(PDF.Name, PDF.PDFStream);

          var XML = response["XML"];
          this.download(XML.Name, XML.PDFStream);
        }
      }
  
      this.DocumentBodyLoading = false;
    });
  }

  ShowEFacturaQuestion:boolean;

  UploadEFactura(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoiceID:this.CurrentInvoice.ID,
      InvoiceDetailsID:this.CurrentInvoice.Details.ID,
    };
  
    this.DocumentBodyLoading = true;
  
    this.service.UploadEFactura(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentInvoice.Details.EFacturaDetails = response["EFacturaDetails"];
      }
  
      this.DocumentBodyLoading = false;
      this.parent.RedirectToURL('dashboard/documents/invoices');
    });
  }

  UpdateInvoiceDetails(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Details:this.CurrentInvoice.Details,
      InvoiceID:this.CurrentInvoice.ID
    };

    this.parent.loading = true;

    this.service.UpdateInvoiceDetails(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.GetInvoice(this.CurrentInvoice.ID, true, true);
        this.showInvoiceVisualizer = true;
      }
    
      this.parent.loading = false;
    });
  }

  UpdateInvoice(){
    this.CurrentInvoice.Client = this.partner;
    this.CurrentInvoice.Currency = this.currency;
    
    if(this.DocumentDate.value._d != undefined){
      this.CurrentInvoice.DocumentDate = moment(this.DocumentDate.value._d).format('YYYY-MM-DD');
    }

    if(this.PaymentDueDate.value._d != undefined){
      this.CurrentInvoice.PaymentDueDate = moment(this.PaymentDueDate.value._d).format('YYYY-MM-DD');
    }

    this.CurrentInvoice.Currency.DecimalPrecision = this.InvoicePrecision;
    this.CurrentInvoice.Products = this.Products;
    this.CurrentInvoice.IsStorno = this.IsStorno;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Invoice:this.CurrentInvoice
    };

    this.parent.loading = true;

    this.service.UpdateInvoice(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.GetInvoice(this.CurrentInvoice.ID, true, true);
        this.showInvoiceVisualizer = true;
      }

      this.DocumentDate = new FormControl(moment(this.CurrentInvoice.DocumentDate));
      this.PaymentDueDate =  new FormControl(moment(this.CurrentInvoice.PaymentDueDate));
      this.parent.loading = false;
    });
  }

  printPage(name:string, html:string, ID:string) {
    var winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
    'resizable,screenX=50,screenY=50,width=850,height=1050';

var htmlPop = '<embed width=100% height=100%'
    + ' type="application/pdf"'
    + ' src="data:application/pdf;base64,'
    + escape(html)
    + '"></embed>';

var newWindow = window.open("", 'PDF_' + name +"_"+ ID);
newWindow.document.write(htmlPop);
};

  PrintInvoice(i:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoiceID:i.ID,
    };

    this.DocumentBodyLoading = true;

    this.service.ExportInvoice(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.printPage(Document.Name , Document.PDFStream, Document.ID);
      }

      this.DocumentBodyLoading = false;
    });
  }

  download(filename, text) {
    var element = document.createElement('a');

    // Determine MIME type based on file extension
    let mimeType = 'application/pdf';
    if (filename && filename.toLowerCase().endsWith('.xlsx')) {
      mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    } else if (filename && filename.toLowerCase().endsWith('.xls')) {
      mimeType = 'application/vnd.ms-excel';
    }

    element.setAttribute('href', 'data:' + mimeType + ';base64,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
}

  ExportInvoice(i:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoiceID:i.ID,
    };

    this.DocumentBodyLoading = true;

    this.service.ExportInvoice(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.download(Document.Name, Document.PDFStream);
      }

      this.DocumentBodyLoading = false;
    });
  }

  ExportAutoEvaluation(i:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoiceID:i.ID,
    };

    this.ExportAutoEvaluationLoading = true;

    this.service.ExportAutoEvaluationDocuments(request).subscribe(response => {
      try {
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          var Documents = response["Documents"];
          // Store auto-evaluation documents for display in UI
          this.AutoEvaluationDocuments = Documents || [];

          // Download all documents
          if(Documents && Documents.length > 0){
            this.AnyCustomFormHasDocument = true;  // Enable "Next" button
            Documents.forEach((doc: any) => {
              this.download(doc.Name, doc.PDFStream);
            });
          }
        }
      } catch (error) {
        console.error("Error processing auto-evaluation response:", error);
        this.parent.openSnackBar("Error processing auto-evaluation documents", "OK", "alert-info-snackbar");
      }

      this.ExportAutoEvaluationLoading = false;
    }, error => {
      console.error("Auto-evaluation API error:", error);
      this.parent.openSnackBar("An error occurred with auto-evaluation export", "OK", "alert-info-snackbar");
      this.ExportAutoEvaluationLoading = false;
    });
  }

  ValidDocument:boolean;

  TestDocumentValidity(){

    this.ValidDocument = true;

    if(this.Products == null || this.Products.length == 0){
      this.ValidDocument = false;
    }

    if(this.DocumentDate.valid == false || this.PaymentDueDate.valid == false){
      this.ValidDocument = false;
    }

    if(this.partner == null){
      this.ValidDocument = false;
    }
  }

  ngAfterContentInit() {
    this.loading = false;
  }

  ShowProformaInvoiceConvertorQuestion = false;

ConvertProformaToInvoiceQuestion(i:any){
  this.CurrentInvoice = i;
  this.ShowProformaInvoiceConvertorQuestion = true;
}

ConvertProformaToInvoice(id:string){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),

    InvoiceID:id
  };
  
  this.parent.loading = true;

  this.service.ConvertProformaToInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){

      this.ShowProformaInvoiceConvertorQuestion = false;
      this.GetInvoice(this.CurrentInvoice.ID, true);
      this.showInvoiceVisualizer = true;
    }
 
    this.parent.loading = false;
  });
}

GetAdvancePaymentTotal(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Total:this.CurrentInvoice.Total,
    AdvancePaymentPercentage:this.CurrentInvoice.AdvancePaymentPercentage,
    DecimalPrecision:this.InvoicePrecision
  };
  
  this.parent.loading = true;

  this.service.GetAdvancePaymentTotal(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
    
    }
 
    this.parent.loading = false;
  });
}

ImplementAdvancePaymentValues(){

  this.CurrentInvoice.Currency.DecimalPrecision = this.InvoicePrecision;

  if(this.DocumentDate.value._d != undefined){
    this.CurrentInvoice.DocumentDate = moment(this.DocumentDate.value._d).format('YYYY-MM-DD');
  }

  if(this.PaymentDueDate.value._d != undefined){
    this.CurrentInvoice.PaymentDueDate = moment(this.PaymentDueDate.value._d).format('YYYY-MM-DD');
  }

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Invoice:JSON.parse(JSON.stringify(this.CurrentInvoice))
  };

  request.Invoice.Products = JSON.parse(JSON.stringify(this.Products));
  this.parent.loading = true;

  this.service.ImplementAdvancePaymentValues(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CurrentInvoice = response["Invoice"];
      this.Products = response["Invoice"].Products;

      this.DocumentDate = new FormControl(moment(this.CurrentInvoice.DocumentDate));
      this.PaymentDueDate =  new FormControl(moment(this.CurrentInvoice.PaymentDueDate));
    }
 
    this.parent.loading = false;
  });
}

AutoPrintDocument(i:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    InvoiceID:i.ID,
  };

  this.DocumentBodyLoading = true;

  this.service.ExportInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.parent.AutoPrintDocument(Document);
    }

    this.DocumentBodyLoading = false;
  });
}

ShowSubordonateProductsAdjustment:boolean;

OpenSubordonateProductsAdjustment(){
  this.ShowSubordonateProductsAdjustment = true;
}

ProductSubordonateAutoAdjust:boolean;
ProductSubordonateFillBacklogDifference:boolean = true;

AutoAdjustProductSubordonateQuantities(AutoAdjust:boolean, Apply:boolean = false){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Product:this.NewProduct,
    AutoAdjust:AutoAdjust,
    FillBacklogDifference:this.ProductSubordonateFillBacklogDifference
  };

  this.parent.loading = true;

  this.service.AutoAdjustProductSubordonateQuantities(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.NewProduct.SubordonatesInfo = response["ProductSubordonatesInfo"];
    }

    this.parent.loading = false;

    if(Apply){
      this.ShowSubordonateProductsAdjustment = false;
    }

  });
}

ProofAllocatesSubordonatesQuantites(){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Products:this.Products,
  };

  if(this.CurrentInvoice.DocType.ID == 0 && this.CurrentInvoice.ID == null){
    this.parent.loading = true;

    this.service.ProofAllocatesSubordonatesQuantites(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Products = response["Products"];
      }
  
      this.parent.loading = false;
    });
  }
}

VerifyPriceModel(p:string){
  var result = this.parent.NormalizePrice(p);

  if(this.CurrentProduct != null){
    if(!this.CurrentProduct.ProductInvoiceInfo.PriceContainsVAT){
      this.CurrentProduct.ProductInvoiceInfo.Price.UIUnitPrice = result;
    }
    else{
      this.CurrentProduct.ProductInvoiceInfo.Price.UIVATUnitPrice = result;
    }
  }

  if(this.NewProduct != null){
    if(!this.NewProductPriceContainsVAT){
      this.NewProduct.ProductInvoiceInfo.Price.UIUnitPrice = result;
    }
    else{
      this.NewProduct.ProductInvoiceInfo.Price.UIVATUnitPrice = result;
    }
  }
}

GetShippingDetails(DetailsID:number, PartnerID:string){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ParentDetailsID:DetailsID,
    ShippingMasterData:this.ShippingMasterData,
    PartnerID:PartnerID
  };

  this.parent.loading = true;

  this.service.GetInvoiceShippingDetails(request).subscribe(response => {
 
    if(response["Status"] == -1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CurrentInvoice.Details.ShippingDetails = response["ShippingDetails"];
      this.ShowShippingDetailsContainer = true;
    }
    else if(response["Status"] == 0){
      this.parent.openSnackBar(response["Message"], "OK", "warning-info-snackbar");
      this.CurrentInvoice.Details.ShippingDetails = response["ShippingDetails"];
      this.ShowShippingDetailsContainer = true;
    }

    this.parent.loading = false;
  });
}

AddNewBox(ShippingDetailsID:number){
  var box = {
    ID:0,
    ParentShippingDetailsID:ShippingDetailsID,
    Length:10,
    Width:10,
    Height:10,
    Weight:1,
    TrackingLabel:null,
    UIID:this.parent.newGuid(),
  };

  this.CurrentInvoice.Details.ShippingDetails.Boxes.push(box);
}

ProofShippingDetails(ShippingDetails:number, SaveToDB:boolean = false){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ShippingDetails:ShippingDetails,
  };

  this.service.ProofShippingDetails(request).subscribe(response => {
 
    if(response["Status"] == -1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ShowShippingDetailsContainer = false;

      if(SaveToDB == true){

        if(this.CurrentInvoice.Details.ShippingDetails.ID > 0){
          this.UpdateShippingDetails(this.CurrentInvoice.Details.ShippingDetails);
        }
        else{
          this.AddShippingDetails(this.CurrentInvoice.Details.ShippingDetails);
        }
      }
    }
  });
}

ShowDeleteBoxQuestion:boolean;
CurrentBox:any;

DeleteBox(box:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    BoxID:box.ID
  };

  this.parent.loading = true;

  this.service.DeleteInvoiceBox(request).subscribe(response => {
 
    if(response["Status"] == -1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CurrentInvoice.Details.ShippingDetails.Boxes = this.CurrentInvoice.Details.ShippingDetails.Boxes.filter(item => item.UIID != box.UIID);
    }

    this.parent.loading = false;
  });
}

AddShippingDetails(ShippingDetails:any){
  
  ShippingDetails.Partner = this.CurrentInvoice.Client;

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ShippingDetails:ShippingDetails,
  };

  this.parent.loading = true;

  this.service.AddShippingDetails(request).subscribe(response => {
 
    if(response["Status"] == -1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CurrentInvoice.Details.ShippingDetails = response["ShippingDetails"];
    }

    this.parent.loading = false;
  });
}

UpdateShippingDetails(ShippingDetails:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ShippingDetails:ShippingDetails,
  };

  this.parent.loading = true;

  this.service.UpdateShippingDetails(request).subscribe(response => {
 
    if(response["Status"] == -1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CurrentInvoice.Details.ShippingDetails = response["ShippingDetails"];
    }

    this.parent.loading = false;
  });
} 

TrackInvoice(i:any){

  if(i.Details?.ShippingDetails?.TrackingLabel?.length > 0){
    const nextUrl = this.router.serializeUrl(this.router.createUrlTree(['/management/track/shipment'], { queryParams: { Courier: i.Details.ShippingDetails.ShippingCompany.Name, Tracking: i.Details.ShippingDetails.TrackingLabel } }));
    window.open(nextUrl, '_blank');
  }
}

UploadInvoiceToCarrierLoading:boolean = false;

UploadInvoiceToCarrier(){
  if(!this.CurrentInvoice?.ID || !this.CurrentInvoice?.Details?.ShippingDetails?.TrackingLabel){
    return;
  }

  this.UploadInvoiceToCarrierLoading = true;

  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    InvoiceID: this.CurrentInvoice.ID
  };

  this.service.UploadInvoiceToCarrier(request).subscribe(response => {
    if(response["Status"] == 1){
      this.parent.openSnackBar(response["Message"] || "Invoice uploaded successfully", "OK", "alert-success-snackbar");

      // Update local model so button switches to green "uploaded" state
      if(!this.CurrentInvoice.Details.ShippingDetails.ETDUploadStatus){
        this.CurrentInvoice.Details.ShippingDetails.ETDUploadStatus = {};
      }
      this.CurrentInvoice.Details.ShippingDetails.ETDUploadStatus.ID = 1;
      this.CurrentInvoice.Details.ShippingDetails.ETDUploadTraceID = response["DocId"] || null;
    } else {
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      if(!this.CurrentInvoice.Details.ShippingDetails.ETDUploadStatus){
        this.CurrentInvoice.Details.ShippingDetails.ETDUploadStatus = {};
      }
      this.CurrentInvoice.Details.ShippingDetails.ETDUploadStatus.ID = -2;
      this.CurrentInvoice.Details.ShippingDetails.ETDUploadTraceID = null;
    }
    this.UploadInvoiceToCarrierLoading = false;
  }, error => {
    this.parent.openSnackBar("Error uploading invoice to carrier", "OK", "alert-info-snackbar");
    if(!this.CurrentInvoice.Details.ShippingDetails.ETDUploadStatus){
      this.CurrentInvoice.Details.ShippingDetails.ETDUploadStatus = {};
    }
    this.CurrentInvoice.Details.ShippingDetails.ETDUploadStatus.ID = -2;
    this.CurrentInvoice.Details.ShippingDetails.ETDUploadTraceID = null;
    this.UploadInvoiceToCarrierLoading = false;
  });
}

ShowPrepareInvoiceForExportStepZero:boolean = false;

// Tab mode for Step Zero panel: 'invoice' or 'missing_descriptions'
ExportPanelTab: string = 'invoice';
HSCodesWithoutDescriptions: any[] = [];
HSCodesWithoutDescriptionsLoading: boolean = false;

PrepareInvoiceForExportStepZero(){
  this.ShowPrepareInvoiceForExportStepZero = true;
  this.ExportPanelTab = 'invoice'; // Reset to invoice tab when opening

  // Pre-select all products when opening the export panel
  this.AllSelected = true;
  this.CurrentInvoice?.Products?.forEach(p => {
    p.IsSelected = true;
  });
  this.CheckIfAnyChecked();
}

GetHSCodesWithoutDescriptions(){
  this.HSCodesWithoutDescriptionsLoading = true;
  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    LanguageID: 0 // Will be resolved by backend based on Language string
  };

  this.service.GetHSCodesWithoutDescriptions(request).subscribe(response => {
    if(response["Status"] == 1){
      this.HSCodesWithoutDescriptions = response["HSCodes"] || [];
    } else {
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      this.HSCodesWithoutDescriptions = [];
    }
    this.HSCodesWithoutDescriptionsLoading = false;
  });
}

SaveHSCodeDescriptions(hsCode: any){
  const hasEN = hsCode.NewDescriptionEN && hsCode.NewDescriptionEN.trim() !== '';
  const hasRO = hsCode.NewDescriptionRO && hsCode.NewDescriptionRO.trim() !== '';

  if(!hasEN && !hasRO){
    this.parent.openSnackBar("Please enter at least one description", "OK", "alert-info-snackbar");
    return;
  }

  // Get language objects from masterData - they contain the correct database IDs
  const languages = this.parent.masterData?.Languages || [];
  const englishLang = languages.find((l: any) => l.Name?.toLowerCase() === 'en');
  const romanianLang = languages.find((l: any) => l.Name?.toLowerCase() === 'ro');

  if((hasEN && !englishLang) || (hasRO && !romanianLang)){
    this.parent.openSnackBar("Language configuration not found. Please refresh the page.", "OK", "alert-info-snackbar");
    return;
  }

  hsCode.Saving = true;
  let pendingRequests = 0;
  let successCount = 0;
  let errorMessages: string[] = [];

  const checkCompletion = () => {
    pendingRequests--;
    if(pendingRequests === 0){
      hsCode.Saving = false;
      if(successCount > 0){
        this.parent.openSnackBar(`${successCount} description(s) saved successfully`, "OK", "alert-success-snackbar");
        // Remove from list since it now has at least one description
        this.HSCodesWithoutDescriptions = this.HSCodesWithoutDescriptions.filter(h => h.ID !== hsCode.ID);
      }
      if(errorMessages.length > 0){
        this.parent.openSnackBar(errorMessages.join('; '), "OK", "alert-info-snackbar");
      }
    }
  };

  // Save English description using actual Language ID from masterData
  if(hasEN && englishLang){
    pendingRequests++;
    var requestEN = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      HSCodeDescription: {
        DBID: 0,
        ParentHSCodeID: hsCode.ID,
        Description: hsCode.NewDescriptionEN,
        Language: englishLang
      }
    };
    this.service.AddUpdateHSCodeDescription(requestEN).subscribe(response => {
      if(response["Status"] == 1){
        successCount++;
      } else {
        errorMessages.push("EN: " + response["Message"]);
      }
      checkCompletion();
    });
  }

  // Save Romanian description using actual Language ID from masterData
  if(hasRO && romanianLang){
    pendingRequests++;
    var requestRO = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      HSCodeDescription: {
        DBID: 0,
        ParentHSCodeID: hsCode.ID,
        Description: hsCode.NewDescriptionRO,
        Language: romanianLang
      }
    };
    this.service.AddUpdateHSCodeDescription(requestRO).subscribe(response => {
      if(response["Status"] == 1){
        successCount++;
      } else {
        errorMessages.push("RO: " + response["Message"]);
      }
      checkCompletion();
    });
  }
}

HSCodesAssiciationLoading:boolean = false;
SelectedBulkHSCode: any = null; // Stores the HSCode selected for bulk assignment

AssociateInvoiceProductsHSCodes(){
  // Check if we have selected products for Mode 2 (bulk assignment)
  var selectedProductIDs: string[] = [];
  this.CurrentInvoice.Products.forEach((p:any) => {
    if(p.IsSelected && p.ProductInvoiceInfo?.ID){
      selectedProductIDs.push(p.ProductInvoiceInfo.ID);
    }
  });

  // If we have selected products AND a bulk HSCode selected, use Mode 2
  if(selectedProductIDs.length > 0 && this.SelectedBulkHSCode != null){
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      InvoiceID: this.CurrentInvoice.ID,
      NewHSCode: this.SelectedBulkHSCode,
      SelectedProductIDs: selectedProductIDs
    };

    this.HSCodesAssiciationLoading = true;

    this.service.AutoAssociateHSCodes(request).subscribe(response => {
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        // Update products with response to show new HSCode and descriptions
        var returnedProducts = response["Invoice"]?.Products ?? [];

        this.CurrentInvoice.Products.forEach((currentProduct:any) => {
          var matchedProduct = returnedProducts.find(
            (rp:any) => rp.ProductInvoiceInfo?.ID === currentProduct.ProductInvoiceInfo?.ID
          );

          if(matchedProduct && matchedProduct.ProductInvoiceInfo){
            currentProduct.ProductInvoiceInfo.HSCode = matchedProduct.ProductInvoiceInfo.HSCode;
            currentProduct.ProductInvoiceInfo.DescriptionRows = matchedProduct.ProductInvoiceInfo.DescriptionRows;
            currentProduct.ProductInvoiceInfo.Description = matchedProduct.ProductInvoiceInfo.Description;
            currentProduct.Description = matchedProduct.Description;
          }
        });

        this.parent.openSnackBar("HS Codes assigned successfully", "OK", "alert-success-snackbar");
      }

      this.HSCodesAssiciationLoading = false;
      this.SelectedBulkHSCode = null; // Clear selection after assignment
    });
  }
  else {
    // Original behavior - associate HSCodes for individual products
    var originalRequest = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Invoice:this.CurrentInvoice,
    };

    this.HSCodesAssiciationLoading = true;

    this.service.AssociateInvoiceProductsHSCodes(originalRequest).subscribe(response => {

      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.FillInvoiceInfo(response["Invoice"]);
      }

      this.HSCodesAssiciationLoading = false;
    });
  }
}

AutoAssociateHSCodesLoading:boolean = false;

AutoAssociateHSCodes(){
  if(!this.CurrentInvoice?.ID){
    this.parent.openSnackBar("Invoice must be saved first", "OK", "alert-info-snackbar");
    return;
  }

  // Mode 1: Auto-match HS Codes based on brand/product name matching
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    InvoiceID:this.CurrentInvoice.ID,
  };

  this.AutoAssociateHSCodesLoading = true;

  this.service.AutoAssociateHSCodes(request).subscribe(response => {

    if(response["Status"] == -1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      // Update products one-by-one by matching IDs to preserve UI state
      var returnedProducts = response["Invoice"]?.Products ?? [];

      this.CurrentInvoice.Products.forEach(currentProduct => {
        var matchedProduct = returnedProducts.find(
          (rp:any) => rp.ProductInvoiceInfo?.ID === currentProduct.ProductInvoiceInfo?.ID
        );

        if(matchedProduct && matchedProduct.ProductInvoiceInfo){
          // Update HSCode and descriptions
          currentProduct.ProductInvoiceInfo.HSCode = matchedProduct.ProductInvoiceInfo.HSCode;
          currentProduct.ProductInvoiceInfo.DescriptionRows = matchedProduct.ProductInvoiceInfo.DescriptionRows;
          currentProduct.ProductInvoiceInfo.Description = matchedProduct.ProductInvoiceInfo.Description;
          currentProduct.Description = matchedProduct.Description;
        }
      });

      this.parent.openSnackBar("HS Codes auto-associated successfully", "OK", "alert-success-snackbar");
    }

    this.AutoAssociateHSCodesLoading = false;
  });
}

AnyChecked:boolean;
AllSelected:boolean;

CheckIfAnyChecked(){
  this.AnyChecked = false;

  this.CurrentInvoice.Products.forEach(element => {
    if(element.IsSelected){
      this.AnyChecked = true;
    }
  });
}

SelectAll(){
  this.CurrentInvoice.Products.forEach(p => {
    p.IsSelected = this.AllSelected;
    
    // Clear individual product HS search when Select All is used
    if (this.AllSelected) {
      p.HSCodeSearchTerm = '';
      p.HSCodeSearchResults = [];
    }
  });

  this.CheckIfAnyChecked();
}

HSFilter: {[k: string]: any} = {};

InitializeHSFilter(){

  this.HSFilter = {};
  this.HSFilter.Code = "";

  this.HSFilter.Pager = {};
  this.HSFilter.Pager.PageIndex = 1;
  this.HSFilter.Pager.PageSize = 50;
  this.HSFilter.Pager.TotalCount = 0;
}

hsloading:boolean = false;
HSCodes:any[] = [];

GetHSCodesFiltered(searchterm:string){  

  this.HSFilter.Code = searchterm;

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.HSFilter
  };

  this.hsloading = true;

  this.service.GetHSCodesFiltered(request).subscribe(response => {
 
    if(response["Status"] == -1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.HSCodes = response["HSCodes"];
    }

    this.hsloading = false;
  });
} 

GetHSCodesFilteredIndividual(searchterm:string, p:any){  

  this.HSFilter.Code = searchterm;

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.HSFilter
  };

  this.hsloading = true;

  this.service.GetHSCodesFiltered(request).subscribe(response => {
 
    if(response["Status"] == -1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      p.HSCodeSearchResults = JSON.parse(JSON.stringify(response["HSCodes"]));
    }

    this.hsloading = false;
  });
}

onProductHSSearchChange(searchTerm: string, productIndex: number) {
  const product = this.CurrentInvoice.Products[productIndex];
  if (searchTerm && searchTerm.length > 2) {
    this.GetHSCodesFilteredIndividual(searchTerm, product);
  } else {
    product.HSCodeSearchResults = [];
  }
}

clearProductHSSearch(productIndex: number) {
  const product = this.CurrentInvoice.Products[productIndex];
  product.HSCodeSearchTerm = '';
  product.HSCodeSearchResults = [];
}

SelectHSCodeForProduct(hsCode: any, productIndex: number) {
  const product = this.CurrentInvoice.Products[productIndex];
  product.HSCodeSearchTerm = hsCode.Code;
  product.HSCodeSearchResults = [];
  product.ProductInvoiceInfo.HSCode = hsCode;
}

SelectHSCodeForAll(hsCode: any) {
  // Store the selected HSCode for bulk assignment
  this.SelectedBulkHSCode = hsCode;
  this.HSFilter.Code = hsCode.Code;
  this.HSCodes = [];

  // Show feedback that HSCode is selected - user should click "Associate HSCodes" button to apply
  this.parent.openSnackBar("HS Code selected. Click 'Associate HS Codes' button to apply to selected products.", "OK", "alert-info-snackbar");
}

ValidateAndSanitizeHSCodeGlobal(){
  if(!this.HSFilter.Code || this.HSFilter.Code.trim() === '') return;
  this.service.ValidateHSCode({
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    Code: this.HSFilter.Code,
  }).subscribe(response => {
    if(response["Status"] == 1){
      this.HSFilter.Code = response["SanitizedCode"];
    }
  });
}

ValidateAndSanitizeHSCodeProduct(productIndex: number){
  const product = this.CurrentInvoice.Products[productIndex];
  if(!product.HSCodeSearchTerm || product.HSCodeSearchTerm.trim() === '') return;
  this.service.ValidateHSCode({
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    Code: product.HSCodeSearchTerm,
  }).subscribe(response => {
    if(response["Status"] == 1){
      product.HSCodeSearchTerm = response["SanitizedCode"];
    }
  });
}

getHSCodeParts(code: string): { valid: string, excess: string, hasExcess: boolean } {
  if (!code) return { valid: '', excess: '', hasExcess: false };
  let digitCount = 0;
  let splitIndex = code.length;
  for (let i = 0; i < code.length; i++) {
    if (code[i] >= '0' && code[i] <= '9') {
      digitCount++;
      if (digitCount > 8) { splitIndex = i; break; }
    }
  }
  if (digitCount <= 8) return { valid: code, excess: '', hasExcess: false };
  return { valid: code.substring(0, splitIndex), excess: code.substring(splitIndex), hasExcess: true };
}

PrepareInvoiceForExportLoading:boolean;
ShowPrepareInvoiceForExportStepOne:boolean;
CustomsForms: any[] = [];

PrepareInvoiceForExportStepOne(){
  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    Invoice: this.CurrentInvoice
  };

  this.PrepareInvoiceForExportLoading = true;

  this.service.PrepareInvoiceForExportStepOne(request).subscribe(response => {
    if (response["Status"] == -1) {
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if (response["Status"] == 1) {
      // Filter out Auto Evaluation forms since they're displayed in a separate section
      const allForms = response["CustomsForms"] || [];
      this.CustomsForms = allForms.filter((form: any) => {
        const nameLC = (form.Name || '').toLowerCase();
        const idLC = (form.ID || '').toString().toLowerCase();
        // Exclude forms that are Auto Evaluation (displayed separately)
        return !nameLC.includes('autoevaluation') &&
               !nameLC.includes('auto evaluation') &&
               !nameLC.includes('auto-evaluation') &&
               !idLC.includes('autoevaluation') &&
               !idLC.includes('auto_evaluation');
      });
      this.ShowPrepareInvoiceForExportStepZero = false;
      this.ShowPrepareInvoiceForExportStepOne = true;
    }

    this.PrepareInvoiceForExportLoading = false;
  });
}

PrepareInvoiceForExportStepTwo(){
  // Get selected forms with documents
  const selectedForms = this.CustomsForms.filter(f => f.IsSelected && f.Document != null);

  if (selectedForms.length === 0) {
    this.parent.openSnackBar('Please select at least one form with a generated document', 'OK', 'alert-info-snackbar');
    return;
  }

  // Store selected customs forms for email sending
  this.parent.CustomsFormsForEmail = selectedForms;

  // Initialize email container with customs-specific flag
  this.parent.Partner = this.CurrentInvoice.Client;

  // Use CustomsExportForms GeneralDocType (ID = 17) instead of invoice's GeneralDocType
  this.parent.GeneralDocType = { ID: 17, Name: 'CustomsExportForms' };

  this.parent.EmailDocumentID = this.CurrentInvoice.ID;
  this.parent.IsCustomsEmail = true; // Flag to indicate this is customs email
  this.parent.GetCompanySMTPConfigs();
  this.parent.EmailMessage.SendWithAttachment = true;

  // Close Step 1 and open email container
  this.ShowPrepareInvoiceForExportStepOne = false;
  this.parent.ShowEmailSendContainer = true;
}

onProductDoubleClick(productIndex: number) {
  const product = this.CurrentInvoice.Products[productIndex];
  const newSelectionState = !product.IsSelected;
  
  // Set all products to the same selection state as the double-clicked product
  this.CurrentInvoice.Products.forEach(p => {
    p.IsSelected = newSelectionState;
    
    // Clear individual product HS search when selecting all
    if (newSelectionState) {
      p.HSCodeSearchTerm = '';
      p.HSCodeSearchResults = [];
    }
  });
  
  // Uncheck the Select All checkbox
  this.AllSelected = false;
  
  this.CheckIfAnyChecked();
}

downloadCustomsForm(customsForm: any) {
  if (customsForm.Documents && customsForm.Documents.length > 0) {
    customsForm.Documents.forEach((doc: any) => {
      this.download(doc.Name, doc.PDFStream);
    });
  }
}

AllCustomsFormsSelected: boolean = false;
AutoEvaluationIsSelected: boolean = false;

SelectAllCustomsForms() {
  this.CustomsForms.forEach(form => {
    form.IsSelected = this.AllCustomsFormsSelected;
  });
  // Also select/deselect auto-evaluation when "Select All" is toggled
  this.AutoEvaluationIsSelected = this.AllCustomsFormsSelected;
}

PrepareCustomsFormsDocumentsLoading: boolean = false;
PrepareCustomsFormsDocumentsLoadingFormId: string = null;
AnyCustomFormHasDocument:boolean = false;
AutoEvaluationDocuments: any[] = [];  // Store auto-evaluation documents for display/download

PrepareCustomsFormsDocuments(form: any = null, IsAllSelected:boolean = false) {
  // Always set ParentDocumentID for all forms first
  this.CustomsForms.forEach(f => {
    f.ParentDocumentID = this.CurrentInvoice.ID;
  });

  // Set IsSelected for the forms we want to process
  if (form) {
    // Single form clicked - set only this form as selected
    this.CustomsForms.forEach(f => {
      f.IsSelected = false;
    });
    form.IsSelected = true;
    form.IsLoading = true;
  }
  else if(IsAllSelected == true){
    this.CustomsForms.forEach(f => {
      f.IsSelected = true;
      f.IsLoading = true;
    });
  }
  else {
    // "Prepare All Selected" clicked - set loading for selected forms
    this.CustomsForms.forEach(f => {
      if (f.IsSelected) {
        f.IsLoading = true;
      }
    });
  }

  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    Invoice: this.CurrentInvoice,
    CustomsForms: this.CustomsForms  // Send ALL forms with correct IsSelected state
  };

  this.PrepareCustomsFormsDocumentsLoading = true;
  this.PrepareCustomsFormsDocumentsLoadingFormId = form ? form.ID : 'all';

  // Process customs forms with error handling
  this.service.PrepareCustomsFormsDocuments(request).subscribe(response => {
    try {
      if (response["Status"] == -1) {
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if (response["Status"] == 1) {
        const updatedForms = response["CustomsForms"];

        updatedForms.forEach(updatedForm => {
          const existingFormIndex = this.CustomsForms.findIndex(f => f.ID === updatedForm.ID);
          if (existingFormIndex !== -1) {
            // Update the Documents list, keep IsLoading and other properties
            this.CustomsForms[existingFormIndex].Documents = updatedForm.Documents;

            // Download all documents for this form
            if (updatedForm.Documents && updatedForm.Documents.length > 0) {
              this.AnyCustomFormHasDocument = true;

              updatedForm.Documents.forEach((doc: any) => {
                this.download(doc.Name, doc.PDFStream);
              });
            }
          }
        });
      }
    } catch (customsFormsError) {
      console.error("Error processing customs forms response:", customsFormsError);
      this.parent.openSnackBar("Error processing customs forms", "OK", "alert-info-snackbar");
    }

    // Reset loading states
    this.CustomsForms.forEach(f => f.IsLoading = false);
    this.PrepareCustomsFormsDocumentsLoading = false;
    this.PrepareCustomsFormsDocumentsLoadingFormId = null;
  }, error => {
    console.error("Customs forms API error:", error);
    this.parent.openSnackBar("An error occurred with customs forms", "OK", "alert-info-snackbar");

    this.CustomsForms.forEach(f => f.IsLoading = false);
    this.PrepareCustomsFormsDocumentsLoading = false;
    this.PrepareCustomsFormsDocumentsLoadingFormId = null;
  });
}

// Helper method to export auto-evaluation documents inline (with separate error handling)
ExportAutoEvaluationInline() {
  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    InvoiceID: this.CurrentInvoice.ID,
  };

  this.service.ExportAutoEvaluationDocuments(request).subscribe(response => {
    try {
      if (response["Status"] != 1) {
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if (response["Status"] == 1) {
        var Documents = response["Documents"];
        // Store auto-evaluation documents for display in UI
        this.AutoEvaluationDocuments = Documents || [];

        // Download all auto-evaluation documents
        if (Documents && Documents.length > 0) {
          this.AnyCustomFormHasDocument = true;  // Enable "Next" button
          Documents.forEach((doc: any) => {
            this.download(doc.Name, doc.PDFStream);
          });
        }
      }
    } catch (autoEvalError) {
      console.error("Error processing auto-evaluation response:", autoEvalError);
      this.parent.openSnackBar("Error processing auto-evaluation documents", "OK", "alert-info-snackbar");
    }
  }, error => {
    console.error("Auto-evaluation API error:", error);
    this.parent.openSnackBar("An error occurred with auto-evaluation export", "OK", "alert-info-snackbar");
    // Continue without stopping - this error should not affect other operations
  });
}

// Download a specific auto-evaluation document
downloadAutoEvaluationDocument(doc: any) {
  if (doc && doc.Name && doc.PDFStream) {
    this.download(doc.Name, doc.PDFStream);
  }
}

// ========== EMAIL TO CARRIER FEATURE ==========
ShowEmailToCarrierContainer: boolean = false;
EmailToCarrierLoading: boolean = false;
CarrierSMTPConfigs: any[] = [];
CarrierCurrentSMTP: any;
CarrierSMTPEmails: any[] = [];
CarrierSupportContacts: any[] = [];
CarrierCurrentSupportContact: any;
CarrierEmailSubject: string = '';
CarrierEmailBody: string = '';
CarrierEmailAttachments: any[] = [];
ShowExportAlreadySentConfirm: boolean = false;
ExportSentHistory: any[] = [];
ExportSentHistoryLoading: boolean = false;
ShowExportValidationErrors: boolean = false;
ExportValidationErrors: any[] = [];
ExportValidationSenderLang: string = '';

OpenEmailToCarrierModal() {
  // Reset state
  this.CarrierSupportContacts = [];
  this.CarrierCurrentSupportContact = null;
  this.CarrierEmailAttachments = [];
  this.ShowExportAlreadySentConfirm = false;
  this.ShowExportValidationErrors = false;
  this.ExportValidationErrors = [];
  this.ExportValidationSenderLang = '';
  this.ExportSentHistory = [];

  // Get shipping details from current invoice
  const shippingDetails = this.CurrentInvoice?.Details?.ShippingDetails;
  if (!shippingDetails?.ShippingCompany?.ID) {
    this.parent.openSnackBar('No carrier found for this invoice', 'OK', 'alert-info-snackbar');
    return;
  }

  // Show loading state
  this.EmailToCarrierLoading = true;

  // Step 1: Validate products via backend (HS codes + COO + sender-language descriptions)
  var validateRequest = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    InvoiceID: this.CurrentInvoice.ID
  };

  this.service.ValidateInvoiceForExport(validateRequest).subscribe(validateResponse => {
    if (validateResponse["Status"] == 1 && validateResponse["IsValid"] === false) {
      // Validation failed — show validation errors container
      this.ExportValidationErrors = validateResponse["ProductErrors"] || [];
      this.ExportValidationSenderLang = validateResponse["SenderLanguageCode"]?.toUpperCase() || '';
      this.EmailToCarrierLoading = false;
      this.ShowExportValidationErrors = true;
      return;
    }

    // Validation passed (or could not determine — proceed)
    // Step 2: Check if already sent
    this.CheckAlreadySentAndProceed();

  }, error => {
    // On validation error, proceed anyway (don't block the user)
    this.CheckAlreadySentAndProceed();
  });
}

CloseExportValidationErrors() {
  this.ShowExportValidationErrors = false;
  this.ExportValidationErrors = [];
}

CheckAlreadySentAndProceed() {
  var checkRequest = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    DocumentID: this.CurrentInvoice.ID,
    EmailNotificationTypeID: 5 // eEmailNotificationType.AutomaticExportDeclaration
  };

  this.service.GetAutomaticEmailNotificationsFiltered(checkRequest).subscribe(checkResponse => {
    if (checkResponse["Status"] == 1 && checkResponse["Notifications"]?.length > 0) {
      // Already sent — store history and show confirmation
      this.ExportSentHistory = checkResponse["Notifications"].map((n: any) => {
        n.IsExpanded = false;
        n.ToEmailsList = n.ToEmails ? n.ToEmails.split(' ').filter((e: string) => e.length > 0) : [];
        return n;
      });
      this.EmailToCarrierLoading = false;
      this.ShowExportAlreadySentConfirm = true;

      // Load attachments for each notification
      this.ExportSentHistory.forEach((n: any) => {
        this.service.GetAutomaticEmailNotificationAttachments({
          User: this.parent.User,
          Language: this.parent.getLanguage(),
          NotificationID: n.ID
        }).subscribe(attResponse => {
          if (attResponse["Status"] == 1) {
            n.AttachmentCount = attResponse["Attachments"]?.length || 0;
          }
        });
      });
    } else {
      // Not sent before — proceed directly
      this.ProceedWithEmailToCarrier();
    }
  }, error => {
    // On error, proceed anyway (don't block the user)
    this.ProceedWithEmailToCarrier();
  });
}

ToggleExportHistoryItem(item: any) {
  item.IsExpanded = !item.IsExpanded;
}

ConfirmResendExportEmail() {
  this.ShowExportAlreadySentConfirm = false;
  this.EmailToCarrierLoading = true;
  this.ProceedWithEmailToCarrier();
}

CancelResendExportEmail() {
  this.ShowExportAlreadySentConfirm = false;
  this.ExportSentHistory = [];
}

ProceedWithEmailToCarrier() {
  // Prepare all customs form documents on-the-fly
  this.PrepareAllDocumentsForEmail().then(() => {
    // Gather attachments from prepared customs forms
    this.CustomsForms?.forEach(form => {
      if (form.Documents && form.Documents.length > 0) {
        form.Documents.forEach((doc: any) => {
          this.CarrierEmailAttachments.push({
            Name: doc.Name,
            PDFStream: doc.PDFStream,
            IsSelected: true
          });
        });
      }
    });

    // Also add auto-evaluation documents
    this.AutoEvaluationDocuments?.forEach((doc: any) => {
      this.CarrierEmailAttachments.push({
        Name: doc.Name,
        PDFStream: doc.PDFStream,
        IsSelected: true
      });
    });

    if (this.CarrierEmailAttachments.length === 0) {
      this.parent.openSnackBar('No documents could be prepared', 'OK', 'alert-info-snackbar');
      this.EmailToCarrierLoading = false;
      return;
    }

    // Get carrier support email data
    this.GetCarrierSupportEmailData(this.CurrentInvoice?.Details?.ShippingDetails);
  }).catch(error => {
    console.error("Error preparing documents for email:", error);
    this.parent.openSnackBar('Error preparing documents', 'OK', 'alert-info-snackbar');
    this.EmailToCarrierLoading = false;
  });
}

// Prepare all documents for email attachment (without downloading)
PrepareAllDocumentsForEmail(): Promise<void> {
  return new Promise((resolve, reject) => {
    // Set ParentDocumentID and select all forms
    this.CustomsForms.forEach(f => {
      f.ParentDocumentID = this.CurrentInvoice.ID;
      f.IsSelected = true;
    });

    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Invoice: this.CurrentInvoice,
      CustomsForms: this.CustomsForms
    };

    // Process customs forms
    this.service.PrepareCustomsFormsDocuments(request).subscribe(response => {
      try {
        if (response["Status"] == 1) {
          const updatedForms = response["CustomsForms"];
          updatedForms.forEach((updatedForm: any) => {
            const existingFormIndex = this.CustomsForms.findIndex(f => f.ID === updatedForm.ID);
            if (existingFormIndex !== -1) {
              this.CustomsForms[existingFormIndex].Documents = updatedForm.Documents;
              if (updatedForm.Documents && updatedForm.Documents.length > 0) {
                this.AnyCustomFormHasDocument = true;
              }
            }
          });
        }

        // Also export auto-evaluation documents
        var autoEvalRequest = {
          User: this.parent.User,
          Language: this.parent.getLanguage(),
          InvoiceID: this.CurrentInvoice.ID,
        };

        this.service.ExportAutoEvaluationDocuments(autoEvalRequest).subscribe(autoEvalResponse => {
          if (autoEvalResponse["Status"] == 1) {
            this.AutoEvaluationDocuments = autoEvalResponse["Documents"] || [];
            if (this.AutoEvaluationDocuments.length > 0) {
              this.AnyCustomFormHasDocument = true;
            }
          }
          resolve();
        }, error => {
          // Continue even if auto-evaluation fails
          console.error("Auto-evaluation error:", error);
          resolve();
        });

      } catch (error) {
        reject(error);
      }
    }, error => {
      reject(error);
    });
  });
}

GetCarrierSupportEmailData(shippingDetails: any) {
  // Only pass the required fields to avoid serialization errors with null booleans
  var sanitizedTracking = {
    ShippingCompany: {
      ID: shippingDetails?.ShippingCompany?.ID
    },
    TrackingLabel: shippingDetails?.TrackingLabel || ''
  };

  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    Tracking: sanitizedTracking
  };

  this.service.GetShippingCompanySupportEmailData(request).subscribe(response => {
    this.EmailToCarrierLoading = false;

    if (response["Status"] != 1) {
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    } else if (response["Status"] == 1) {
      const shippingCompany = response["ShippingCompany"];
      const allContacts = shippingCompany?.SupportContacts || [];

      // Filter to only Export Declaration contacts (Category ID = 4)
      this.CarrierSupportContacts = allContacts.filter((c: any) => c.Category?.ID === 4);

      if (this.CarrierSupportContacts.length > 0) {
        // Select the first export declaration contact
        this.SelectCarrierSupportContact(this.CarrierSupportContacts[0]);

        // Set default subject and body with tracking number
        const trackingNumber = shippingDetails?.TrackingLabel || '';
        this.CarrierEmailSubject = this.translate.instant('EmailToCarrierSubject').replace('{0}', trackingNumber);
        this.CarrierEmailBody = this.translate.instant('EmailToCarrierBody').replace('{0}', trackingNumber);

        // Get SMTP configs
        this.GetCarrierSMTPConfigs();
      } else {
        this.parent.openSnackBar(this.translate.instant('NoCarrierContactsFound'), 'OK', 'alert-info-snackbar');
      }
    }
  }, error => {
    console.error("Error fetching carrier support data:", error);
    this.parent.openSnackBar('Error fetching carrier contacts', 'OK', 'alert-info-snackbar');
    this.EmailToCarrierLoading = false;
  });
}

SelectCarrierSupportContact(contact: any) {
  this.CarrierSupportContacts.forEach(c => {
    c.Category.IsSelected = (c.Category.ID === contact.Category.ID);
  });
  this.CarrierCurrentSupportContact = JSON.parse(JSON.stringify(contact));

  // Select all emails by default
  this.CarrierCurrentSupportContact.Emails?.forEach((e: any) => {
    e.IsSelected = true;
  });
}

GetCarrierSMTPConfigs() {
  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    UILanguage: this.parent.getLanguage(),
    CompanyID: this.parent.Company.ID
  };

  this.service.GetCompanySMTPConfigs(request).subscribe(response => {
    if (response["Status"] != 1) {
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    } else if (response["Status"] == 1) {
      this.CarrierSMTPConfigs = response["SMTPConfigs"];

      if (this.CarrierSMTPConfigs.length > 0) {
        this.CarrierCurrentSMTP = this.CarrierSMTPConfigs[0];
        this.GetCarrierSMTPEmails(this.CarrierCurrentSMTP.ID);
      }
    }
  });
}

GetCarrierSMTPEmails(SMTPID: any) {
  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    UILanguage: this.parent.getLanguage(),
    SMTPID: SMTPID
  };

  this.service.GetCompanySMTPEmails(request).subscribe(response => {
    if (response["Status"] != 1) {
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    } else if (response["Status"] == 1) {
      this.CarrierSMTPEmails = response["Emails"];

      // Set default email (user's email if available)
      this.CarrierSMTPEmails.forEach(e => {
        e.IsDefault = (e.Email === this.parent.User.Email);
      });

      // If no match, select first one
      if (!this.CarrierSMTPEmails.some(e => e.IsDefault) && this.CarrierSMTPEmails.length > 0) {
        this.CarrierSMTPEmails[0].IsDefault = true;
      }

      this.ShowEmailToCarrierContainer = true;
    }
  });
}

SelectCarrierSMTPEmail(email: any) {
  this.CarrierSMTPEmails.forEach(e => {
    e.IsDefault = (e.ID === email.ID);
  });
}

ToggleCarrierAttachment(attachment: any) {
  attachment.IsSelected = !attachment.IsSelected;
}

SendExportDeclarationEmail() {
  const selectedEmails = this.CarrierCurrentSupportContact?.Emails?.filter((e: any) => e.IsSelected) || [];
  if (selectedEmails.length === 0) {
    this.parent.openSnackBar('Please select at least one recipient', 'OK', 'alert-info-snackbar');
    return;
  }

  const selectedAttachments = this.CarrierEmailAttachments.filter(a => a.IsSelected);
  if (selectedAttachments.length === 0) {
    this.parent.openSnackBar('Please select at least one attachment', 'OK', 'alert-info-snackbar');
    return;
  }

  const fromEmail = this.CarrierSMTPEmails.find(e => e.IsDefault);
  if (!fromEmail) {
    this.parent.openSnackBar('Please select a sender email', 'OK', 'alert-info-snackbar');
    return;
  }

  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    SMTP: this.CarrierCurrentSMTP,
    FromEmail: fromEmail,
    ToEmails: selectedEmails,
    Subject: this.CarrierEmailSubject,
    Body: this.CarrierEmailBody,
    Attachments: selectedAttachments,
    ShippingDetails: this.CurrentInvoice?.Details?.ShippingDetails
  };

  this.EmailToCarrierLoading = true;

  this.managementService.SendContactSupportEmail(request).subscribe(response => {
    if (response["Status"] != 1) {
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    } else if (response["Status"] == 1) {
      this.parent.openSnackBar('Email sent successfully', 'OK', 'success-info-snackbar');
      this.ShowEmailToCarrierContainer = false;
      // Close the export panel after successful email
      this.ShowPrepareInvoiceForExportStepOne = false;
    }

    this.EmailToCarrierLoading = false;
  });
}

CloseEmailToCarrierModal() {
  this.ShowEmailToCarrierContainer = false;
  this.CarrierEmailAttachments = [];
  this.CarrierCurrentSupportContact = null;
  this.NewCarrierRecipientEmail = '';
}

// ========== CARRIER RECIPIENT MANAGEMENT ==========
NewCarrierRecipientEmail: string = '';
CarrierRecipientSaving: boolean = false;

// Get the current shipping company ID from the invoice
GetCurrentShippingCompanyID(): number {
  return this.CurrentInvoice?.Details?.ShippingDetails?.ShippingCompany?.ID || 0;
}

// Add a new recipient email
AddCarrierRecipientEmail() {
  if (!this.NewCarrierRecipientEmail || this.NewCarrierRecipientEmail.trim() === '') {
    return;
  }

  const shippingCompanyID = this.GetCurrentShippingCompanyID();
  if (!shippingCompanyID) {
    this.parent.openSnackBar('No shipping company found', 'OK', 'alert-info-snackbar');
    return;
  }

  // Category ID 4 is for Export Declaration contacts
  const categoryID = this.CarrierCurrentSupportContact?.Category?.ID || 4;

  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    Email: {
      ID: 0, // New email
      Email: this.NewCarrierRecipientEmail.trim(),
      CategoryID: categoryID,
      ShippingCompanyID: shippingCompanyID
    }
  };

  this.CarrierRecipientSaving = true;

  this.service.AddUpdateShippingCompanySupportEmail(request).subscribe(response => {
    if (response["Status"] != 1) {
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    } else if (response["Status"] == 1) {
      const newEmail = response["Email"];
      newEmail.IsSelected = true; // Auto-select newly added email

      // Initialize Emails array if it doesn't exist
      if (!this.CarrierCurrentSupportContact) {
        this.CarrierCurrentSupportContact = {
          Category: { ID: categoryID },
          Emails: []
        };
      }
      if (!this.CarrierCurrentSupportContact.Emails) {
        this.CarrierCurrentSupportContact.Emails = [];
      }

      this.CarrierCurrentSupportContact.Emails.push(newEmail);
      this.NewCarrierRecipientEmail = '';
      this.parent.openSnackBar('Recipient added successfully', 'OK', 'success-info-snackbar');
    }

    this.CarrierRecipientSaving = false;
  }, error => {
    console.error("Error adding recipient:", error);
    this.parent.openSnackBar('Error adding recipient', 'OK', 'alert-info-snackbar');
    this.CarrierRecipientSaving = false;
  });
}

// Start editing a recipient email
StartEditCarrierRecipient(email: any) {
  email.IsEditing = true;
  email.EditValue = email.Email;
}

// Cancel editing a recipient email
CancelEditCarrierRecipient(email: any) {
  email.IsEditing = false;
  email.EditValue = null;
}

// Save edited recipient email
SaveCarrierRecipientEmail(email: any) {
  if (!email.EditValue || email.EditValue.trim() === '') {
    this.parent.openSnackBar('Email cannot be empty', 'OK', 'alert-info-snackbar');
    return;
  }

  const shippingCompanyID = this.GetCurrentShippingCompanyID();
  const categoryID = this.CarrierCurrentSupportContact?.Category?.ID || 4;

  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    Email: {
      ID: email.ID, // Existing email ID for update
      Email: email.EditValue.trim(),
      CategoryID: categoryID,
      ShippingCompanyID: shippingCompanyID
    }
  };

  this.CarrierRecipientSaving = true;

  this.service.AddUpdateShippingCompanySupportEmail(request).subscribe(response => {
    if (response["Status"] != 1) {
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    } else if (response["Status"] == 1) {
      email.Email = email.EditValue.trim();
      email.IsEditing = false;
      email.EditValue = null;
      this.parent.openSnackBar('Recipient updated successfully', 'OK', 'success-info-snackbar');
    }

    this.CarrierRecipientSaving = false;
  }, error => {
    console.error("Error updating recipient:", error);
    this.parent.openSnackBar('Error updating recipient', 'OK', 'alert-info-snackbar');
    this.CarrierRecipientSaving = false;
  });
}

// Delete recipient confirmation popup state
ShowDeleteRecipientConfirm: boolean = false;
RecipientToDelete: any = null;

// Show delete confirmation popup
DeleteCarrierRecipientEmail(email: any) {
  this.RecipientToDelete = email;
  this.ShowDeleteRecipientConfirm = true;
}

// Cancel delete action
CancelDeleteRecipient() {
  this.ShowDeleteRecipientConfirm = false;
  this.RecipientToDelete = null;
}

// Confirm and execute delete
ConfirmDeleteRecipient() {
  if (!this.RecipientToDelete) {
    return;
  }

  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    DBID: this.RecipientToDelete.ID
  };

  this.CarrierRecipientSaving = true;

  this.service.DeleteShippingCompanySupportEmail(request).subscribe(response => {
    if (response["Status"] != 1) {
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    } else if (response["Status"] == 1) {
      // Remove from local array
      this.CarrierCurrentSupportContact.Emails = this.CarrierCurrentSupportContact.Emails.filter(
        (e: any) => e.ID !== this.RecipientToDelete.ID
      );
      this.parent.openSnackBar('Recipient deleted successfully', 'OK', 'success-info-snackbar');
    }

    this.CarrierRecipientSaving = false;
    this.ShowDeleteRecipientConfirm = false;
    this.RecipientToDelete = null;
  }, error => {
    console.error("Error deleting recipient:", error);
    this.parent.openSnackBar('Error deleting recipient', 'OK', 'alert-info-snackbar');
    this.CarrierRecipientSaving = false;
    this.ShowDeleteRecipientConfirm = false;
    this.RecipientToDelete = null;
  });
}

// ========== DOWNLOAD ALL FORMS AND FINISH ==========
DownloadAllFormsLoading: boolean = false;

DownloadAllFormsAndFinish() {
  // Set loading state
  this.DownloadAllFormsLoading = true;

  // Set ParentDocumentID and select all forms for processing
  this.CustomsForms.forEach(f => {
    f.ParentDocumentID = this.CurrentInvoice.ID;
    f.IsSelected = true;
  });

  // Also select auto-evaluation
  this.AutoEvaluationIsSelected = true;

  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    Invoice: this.CurrentInvoice,
    CustomsForms: this.CustomsForms
  };

  // Prepare all customs forms documents
  this.service.PrepareCustomsFormsDocuments(request).subscribe(response => {
    try {
      if (response["Status"] == -1) {
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        this.DownloadAllFormsLoading = false;
        return;
      }
      else if (response["Status"] == 1) {
        const updatedForms = response["CustomsForms"];

        // Update local forms with documents from response
        updatedForms.forEach((updatedForm: any) => {
          const existingFormIndex = this.CustomsForms.findIndex(f => f.ID === updatedForm.ID);
          if (existingFormIndex !== -1) {
            this.CustomsForms[existingFormIndex].Documents = updatedForm.Documents;
          }
        });

        // Also fetch and prepare auto-evaluation documents
        this.prepareAutoEvaluationForDownload().then(() => {
          // Download all forms sequentially with delay to allow browser to handle multiple downloads
          this.downloadAllFormsSequentially().then(() => {
            this.DownloadAllFormsLoading = false;
            // Close the export panel after all downloads complete
            this.ShowPrepareInvoiceForExportStepOne = false;
            this.parent.openSnackBar('All forms downloaded successfully', 'OK', 'success-info-snackbar');
          });
        });
      }
    } catch (e) {
      console.error("Error processing customs forms:", e);
      this.parent.openSnackBar("Error processing customs forms", "OK", "alert-info-snackbar");
      this.DownloadAllFormsLoading = false;
    }
  }, error => {
    console.error("Customs forms API error:", error);
    this.parent.openSnackBar("An error occurred with customs forms", "OK", "alert-info-snackbar");
    this.DownloadAllFormsLoading = false;
  });
}

// Helper method to prepare auto-evaluation documents for download
prepareAutoEvaluationForDownload(): Promise<void> {
  return new Promise((resolve) => {
    var autoEvalRequest = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      InvoiceID: this.CurrentInvoice.ID,
    };

    this.service.ExportAutoEvaluationDocuments(autoEvalRequest).subscribe(response => {
      try {
        if (response["Status"] == 1) {
          this.AutoEvaluationDocuments = response["Documents"] || [];
        }
      } catch (e) {
        console.error("Error preparing auto-evaluation:", e);
      }
      resolve();
    }, error => {
      console.error("Auto-evaluation API error:", error);
      resolve(); // Continue even if auto-evaluation fails
    });
  });
}

// Helper method to download all forms sequentially with a small delay between each
async downloadAllFormsSequentially(): Promise<void> {
  // Download customs forms
  for (const form of this.CustomsForms) {
    if (form.Documents && form.Documents.length > 0) {
      for (const doc of form.Documents) {
        this.download(doc.Name, doc.PDFStream);
        // Small delay between downloads to prevent browser blocking
        await new Promise(resolve => setTimeout(resolve, 500));
      }
    }
  }

  // Download auto-evaluation documents
  if (this.AutoEvaluationDocuments && this.AutoEvaluationDocuments.length > 0) {
    for (const doc of this.AutoEvaluationDocuments) {
      this.download(doc.Name, doc.PDFStream);
      await new Promise(resolve => setTimeout(resolve, 500));
    }
  }
}

/**
 * Checks if the current invoice has insurance applied
 */
hasInsuranceApplied(): boolean {
  if (!this.CurrentInvoice) {
    return false;
  }

  if (this.CurrentInvoice.Details?.InsurancePolicySnapshot?.HasInsurance === true) {
    return true;
  }

  if (this.CurrentInvoice.Products && this.CurrentInvoice.Products.length > 0) {
    return this.CurrentInvoice.Products.some((p: any) => p.Code === 'Insurance' || p.ProductInvoiceInfo?.Code === 'Insurance');
  }

  return false;
}

// Insurance Policy Settings Container
ShowInsurancePolicyContainer: boolean = false;
InsurancePolicySettings: any = {};
showInsuranceDictatorDropdown: boolean = false;
showInsuranceIllustratorDropdown: boolean = false;

// Track unsaved insurance changes in current session
InsuranceAddedThisSession: boolean = false;
UnsavedInsurancePolicySnapshot: any = null;

/**
 * Opens the insurance policy settings container for adding insurance
 */
openInsurancePolicyContainer() {
  if (!this.CurrentInvoice || !this.CurrentInvoice.ID) {
    this.parent.openSnackBar(this.translate.instant('NoInvoiceSelected'), "OK", "warning-info-snackbar");
    return;
  }

  if (this.CurrentInvoice.DocumentStatus.ID === -1 || this.CurrentInvoice.DocumentStatus.ID === 1) {
    this.parent.openSnackBar(this.translate.instant('InvoiceNotModifiable'), "OK", "warning-info-snackbar");
    return;
  }

  // Initialize with default values or existing snapshot
  if (this.CurrentInvoice.Details?.InsurancePolicySnapshot?.HasInsurance) {
    this.InsurancePolicySettings = JSON.parse(JSON.stringify(this.CurrentInvoice.Details.InsurancePolicySnapshot));
  } else {
    this.InsurancePolicySettings = {
      HasInsurance: true,
      InsuranceValue: 0.5,
      Dictator: this.InsurancePolicyDictators ? this.InsurancePolicyDictators[1] : { ID: 2, Name: 'INSURANCE_DICTATOR_SHIPPING_RESPONSIBILITY' },
      Illustrator: this.InsurancePolicyIllustrators ? this.InsurancePolicyIllustrators[0] : { ID: 1, Name: 'INSURANCE_ILLUSTRATOR_SEPARATE_POSITION' }
    };
  }

  this.ShowInsurancePolicyContainer = true;
}

/**
 * Applies insurance with the custom policy settings from UI
 */
applyInsuranceWithCustomPolicy() {
  this.ShowInsurancePolicyContainer = false;
  this.DocumentBodyLoading = true;

  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    Invoice: this.CurrentInvoice,
    CustomInsurancePolicy: this.InsurancePolicySettings,
    UseCustomPolicy: true
  };

  this.service.ApplyInsurancePolicy(request).subscribe((response: any) => {
    this.DocumentBodyLoading = false;

    if (response["Status"] != 1) {
      this.parent.openSnackBar(response["Message"], "OK", "warning-info-snackbar");
    } else if (response["Status"] == 1) {
      this.CurrentInvoice = response["Invoice"];

      // Update the Products array to reflect the changes in the editable products table
      this.Products = response["Invoice"]["Products"];

      if (response["InsuranceApplied"] === true) {
        // Track that insurance was added this session (not yet saved to DB)
        this.InsuranceAddedThisSession = true;
        this.UnsavedInsurancePolicySnapshot = JSON.parse(JSON.stringify(this.InsurancePolicySettings));

        this.parent.openSnackBar(this.translate.instant('InsuranceAppliedSuccessfully'), "OK", "light-info-snackbar");
      } else if (response["InsuranceApplied"] === false) {
        this.parent.openSnackBar(this.translate.instant('InsuranceRemovedSuccessfully'), "OK", "light-info-snackbar");
      } else {
        this.parent.openSnackBar(this.translate.instant('NoInsuranceChangeNeeded'), "OK", "info-info-snackbar");
      }
    }
  });
}

/**
 * Toggles insurance on/off for the current invoice
 * For adding: opens the settings container
 * For removing: removes directly using the snapshot
 */
toggleInsurance() {
  if (!this.CurrentInvoice || !this.CurrentInvoice.ID) {
    this.parent.openSnackBar(this.translate.instant('NoInvoiceSelected'), "OK", "warning-info-snackbar");
    return;
  }

  if (this.CurrentInvoice.DocumentStatus.ID === -1 || this.CurrentInvoice.DocumentStatus.ID === 1) {
    this.parent.openSnackBar(this.translate.instant('InvoiceNotModifiable'), "OK", "warning-info-snackbar");
    return;
  }

  // If insurance is currently applied, remove it directly
  if (this.hasInsuranceApplied()) {
    this.DocumentBodyLoading = true;

    // If UnsavedInsurancePolicySnapshot has value, it means insurance was applied this session
    // but not yet saved to DB - use it for accurate removal (has Illustrator, InsuranceValue, etc.)
    // Otherwise, let the backend use the saved snapshot from invoice details
    var snapshotForRemoval = this.UnsavedInsurancePolicySnapshot
      ? { ...this.UnsavedInsurancePolicySnapshot, HasInsurance: false }
      : null;

    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Invoice: this.CurrentInvoice,
      CustomInsurancePolicy: snapshotForRemoval,
      UseCustomPolicy: snapshotForRemoval != null  // Only use custom policy if we have unsaved snapshot
    };

    this.service.ApplyInsurancePolicy(request).subscribe((response: any) => {
      this.DocumentBodyLoading = false;

      if (response["Status"] != 1) {
        this.parent.openSnackBar(response["Message"], "OK", "warning-info-snackbar");
      } else if (response["Status"] == 1) {
        this.CurrentInvoice = response["Invoice"];

        // Update the Products array to reflect the changes in the editable products table
        this.Products = response["Invoice"]["Products"];

        // Clear the session tracking flags
        this.InsuranceAddedThisSession = false;
        this.UnsavedInsurancePolicySnapshot = null;

        this.parent.openSnackBar(this.translate.instant('InsuranceRemovedSuccessfully'), "OK", "light-info-snackbar");
      }
    });
  } else {
    // If no insurance, open the settings container to configure and add
    this.openInsurancePolicyContainer();
  }
}

}
